<template>
  <div class="page-wrapper">

    <div class="background-page">
      <!--      <div class="container top-nav fixed-top eemo-yellow">-->
      <!--        <div class="row">-->
      <!--          <div class="col-2">-->

      <!--            <div class="square clickable-elapsed" v-on:click="backPressed">-->
      <!--              <span><i class="fas fa-arrow-left"></i></span>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="col-8">-->
      <!--            <input type="text" class="form-control eemo-gray search-bar text-center" placeholder="테마, 지역, 매장 이름으로 검색"/>-->
      <!--          </div>-->
      <!--          <div class="col-2">-->
      <!--            <div class="square clickable-elapsed">-->
      <!--              <span><i class="fas fa-search"></i></span>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <transition name="slide-fade">
        <div class="background-page level-2"  style="overflow-y: scroll; background:white;" v-if="currentMerchantItem != false"  v-on:scroll="handleScroll" id="menu-page">
          <div class="container " style="background:white;" id="restaurant-panel">
            <!--            <div class="row">-->
            <!--              <div class="col-12 text-left">-->
            <!--                <div class="elapsed-text-box">-->
            <!--                  <h4 style="margin-top: .5rem;">{{currentMerchantItem.title}}</h4>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            v-bind:style="{backgroundImage: 'url(' + currentMerchantItem.imageUrl + ')'}"-->
            <div class="restaurant-image">
              <slider animation="fade" style="height:100%">
                <slider-item
                  v-for="(img, index) in images"
                  :key="index"
                  style="z-index: 0; height:200px;"


                >
                  <div class="restaurant-image" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
                </slider-item>
              </slider>
              <!--              <div class="address-container" v-html="currentMerchantItem.address.replace(/\n/g, '<br>') + '<br>' + currentMerchantItem.contact">-->

              <!--              </div>-->

            </div>


            <!--            <div class="row">-->
            <!--              <div class="col-6 text-left" v-html="currentMerchantItem.address.replace(/\n/g, '<br>') + '<br>' + currentMerchantItem.contact">-->

            <!--              </div>-->
            <!--            </div>-->


          </div>

          <div class="restaurant-title-container level-2" style="position:sticky; top:0;">

            <div class="place-title-container" id="place-title">
              {{currentMerchantItem.title}}
            </div>

          </div>
          <div class="left-top-back level-3" id="back-btn" v-on:click="closeTop">
            <span><i class="fas fa-arrow-left"></i></span>
          </div>
          <div class="place-info-container" style="padding-top:0px;">
            <!--            <div class="place-header">-->
            <!--              <div class="place-service-container">-->
            <!--                <span v-if="currentMerchantItem.webOrder == 1">Takeaway</span>-->
            <!--                <span v-if="currentMerchantItem.webDelivery == 1">Delivery</span>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="place-tag-container">
              {{currentMerchantItem.types}}
            </div>
            <div class="place-bottom-container">
              <i class="fas fa-map-marker"></i> <a :href="'http://maps.google.com/?q=' + currentMerchantItem.address" target="_blank" >{{currentMerchantItem.address}}</a>
              <br>
              <i class="fas fa-phone"></i> <a :href="'tel:' + currentMerchantItem.contact">{{currentMerchantItem.contact}}</a>
              <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
              <br>
              <i class="fas fa-clock"></i> Today <span v-if="isShopOpen==false">Closed</span><template v-else><span v-if="shopSlots.length > 0" v-for="(slot, si) in shopSlots"><span v-if="si > 0"> ,</span>{{slot.fromString}}~{{slot.toString}}</span><span v-else>Closed</span></template>
            </div>

          </div>
          <div class="container level-2" style="position:sticky; top:50px; background-color: white;">
            <div class="row text-style-1" style="padding-top:10px; padding-bottom:10px;background-color: #9C9C9C;">
              <div class="col-6" v-if="order != undefined && order != false && order.list != undefined" v-on:click="showBasketView" >
                <div class="basket-box" id="basket-box">
                  <span class="basket-count"><i class="fas fa-shopping-basket"></i> {{getTotalCount()}}</span> <span>&#160;&#160;&#124;&#160;&#160;</span> £{{Number(order.totalDue/100).toFixed(2)}}
                </div>
              </div>

            </div>
            <div class="row" style="padding-top:10px; padding-bottom: 10px; min-height:40px;border-bottom:1px solid #efeff6;" v-if="currentMerchantItem != false && currentMerchantItem.categories != undefined">
              <div class="col-12 hide-scrollbar horizontal-scroll-container" id="cat-container" style="overflow-x: scroll;scroll-behavior: smooth;-webkit-overflow-scrolling: touch;">
                <ul class="nav nav-tabs" >
                  <li v-for="(cat, index) in currentMerchantItem.categories" ><a class="button-outlined-container button-text cat-button" v-bind:class="{'active': index == 0}" :id="'cat-'+cat.id" v-on:click="onCatClicked(index)" data-toggle="tab" :href="'#cat-' + cat.id">{{cat.name}}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <!--          <div class="container" style="padding-top:310px;" id="menu-list-container">-->
          <div class="container" style="padding-top:10px;" id="menu-list-container">
            <div class="row" v-if="currentMerchantItem != false && currentMerchantItem.categories != undefined">
              <div class="col-12">
                <div class="tab-content">
                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">
                    <!--                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">-->

                    <div class="category-section-title" :id="'category-title-'+cat.id">
                      {{cat.name}}
                    </div>
                    <div class="menu-item-card" v-for="menu in cat.list" v-bind:class="{'sold-out-item': menu.soldOut == 1 || menu.tableAvailable== false}" v-on:click="selectMenuAnim(menu)">
                      <div class="merchant-card-wrapper">

                        <div class="menu-card-info" style="position: relative;">
                          <div class="menu-card-title">
                            <span v-if="menu.public_name == null || menu.public_name.length == 0">{{menu.name}}</span><span v-else>{{menu.public_name}}</span>
                            <span v-if="menu.alcohol != undefined && menu.alcohol == true" class="alcohol"> <i class="fas fa-beer"></i></span>

                          </div>
                          <div class="icon-container"  v-if="menu.icons.length > 0">
                            <div v-for="icon in menu.icons" v-if="icon.selected == true" class="icon-item" v-bind:style="{backgroundImage: 'url(' + icon.url + ')'}"/>

                          </div>
                          <p class="menu-item-description" style="margin-top:10px;" v-if="menu.description != null"><span v-html="menu.description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span></p>
                          <div class="menu-item-price" style="margin-top:10px;">
                            <span v-html="promotionEligable(menu)"></span>
                            <span v-if="menu.soldOut == 1" style="color:#FF795C;"><br>Sold Out</span>
                            <span v-if="menu.soldOut == 0 && menu.pricePoints > 0 &&
                            (order == false || order.pointsUsed == 0) &&
                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > menu.pricePoints">
                              or <span class="points-usable-price" >{{menu.pricePoints}} {{points.unitTitle}}s</span>
                            </span>

                            <span v-if="menu.tableAvailable == false" style="color:#FF795C;"><br>{{menu.tableMessage}}</span>
                          </div>

                          <div v-if="menu.recommended == 1" style="height:40px;line-height: 40px;">
                            <span style="background-color: #FD7474; color:white; font-weight: bold; padding:5px 10px 5px 10px; border-radius:20px;">Recommended</span>
                          </div>
                          <div v-if="menu.popular == 1" style="height:40px;line-height: 40px;">
                            <span style="background-color: #6EC667; color:white; font-weight: bold; padding:5px 10px 5px 10px; border-radius:20px;">Popular</span>
                          </div>
                          <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>
                        </div>
                        <div class="menu-card-image" style="margin-top: 10px;"  v-bind:style="{backgroundImage: 'url(' + menu.imgs[0] + ')'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Bottom
            :item="currentMerchantItem">

          </Bottom>
          <div class="history-icon" v-if="orderHistory != undefined && orderHistory != null && orderHistory.length > 0" v-on:click="showHistoryList">
            <span><i class="fas fa-history"></i></span>
          </div>
          <div class="point-icon" v-if="userPoint != undefined && userPoint != false && userPoint.balance > 0">
            <span>{{userPoint.balance}} {{points.unitTitle}}s</span>
          </div>

        </div>
      </transition>
      <transition name="slide-fade">
        <div class="background-page level-3 eemo-gray h-100" v-if="optionSelectItem != false">
          <div class="container h-100" style="overflow-y: scroll; padding-bottom: 100px;">

            <div class="row" style="background: white; position: sticky; top:0; z-index:2;">
              <div class="col-1 product-detail-title text-left" v-on:click="closeTop">
                <span><i class="fas fa-arrow-left"></i></span>
              </div>
              <div class="col-11 product-detail-title text-left" style="background: white;">
                {{optionSelectItem.publicMenuName}}

              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;background-color:white;">

              <img class="col-12" v-if="optionSelectItem.imgs.length > 0" style="padding-bottom: 0px;" :src="optionSelectItem.imgs[0]">

              </img>
              <div class="col-12" v-else style="height: 70px;">

              </div>

              <!--              <div class="col-12 option-title">-->
              <!--                {{optionSelectItem.publicMenuName}}-->
              <!--              </div>-->


              <div class="col-12 option-description" v-if="getMenuDescription(optionSelectItem.menuId) !== ''">

                <div style="padding-top:20px;padding-bottom:20px;">
                <span v-html="getMenuDescription(optionSelectItem.menuId).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                </div>
                <div v-if="optionSelectItem.youtube != null && optionSelectItem.youtube.length > 0" class="youtube-container">
                  <iframe :src="optionSelectItem.youtube"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div v-if="optionSelectItem.imgs.length > 1" style="padding-bottom: 0px; width:100%;">
                  <img v-for="(img, ii) in optionSelectItem.imgs" v-if="ii > 0" style=" margin-top:10px; width: 100%;" :src="img"/>

                </div>
              </div>

<!--              <div style="position: absolute; left:15px;top:15px; background:yellow; width:40px;height: 40px;border-radius: 20px;line-height: 40px;" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>-->
            </div>
            <div class="row option-selection-title">
              <div class="col-6">
                Price
              </div>
              <div class="col-6 price">
                £{{(optionSelectItem.price/100).toFixed(2)}}<span v-if="optionSelectItem.originalPrice > optionSelectItem.price">&nbsp;&nbsp;<del>£{{(optionSelectItem.originalPrice/100).toFixed(2)}}</del></span>
              </div>

            </div>
<!--            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(option, index) in optionSelectItem.options">-->
<!--              <div class="col-12 option-selection-title">-->
<!--                {{option.name}}-->
<!--              </div>-->

<!--              <div class="col-12">-->
<!--                <ul class="list-group">-->
<!--                  <div class="list-group-item option-item"  v-for="(optionItem, oi) in option.list"-->
<!--                       :key="'option-' + index + '-' + oi"-->
<!--                       v-bind:class="{'selected': optionItem.selected == true}"-->
<!--                       v-on:click="toggleOption(index, oi)">-->
<!--                    {{optionItem.field_name}}-->
<!--                    <span v-if="optionItem.field_icon != undefined && optionItem.field_icon != null "v-html="getFieldIcon(optionItem.field_icon)"></span>-->
<!--                    <span v-if="optionItem.field_price > 0 && (option.base_price == undefined || option.base_price == false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>-->
<!--                    <span v-if="optionItem.field_price >= 0 && (option.base_price != undefined && option.base_price == true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>-->
<!--                  </div>-->
<!--                </ul>-->

<!--              </div>-->

<!--              <div style="width:100%;" v-if="option.children != undefined && option.children != null && option.children.length > 0 && isOptionSelected(option)" v-for="(co, ci) in option.children">-->
<!--                <div class="col-12 option-name">-->
<!--                  {{co.name}}-->
<!--                </div>-->

<!--                <div class="col-12" v-if="co.list != undefined && co.list.length > 0">-->
<!--                  <ul class="list-group">-->
<!--                    <li class="list-group-item option-item"  v-for="(childOptionItem, cci) in co.list"-->
<!--                        :id="'option-selection-' + index + '-' + ci + '-' + cci"-->
<!--                        :key="'option-' + index + '-' + ci + '-' + cci"-->
<!--                        v-bind:class="{'selected': childOptionItem.selected == true}"-->
<!--                        v-on:click="toggleOption(index, ci, cci)">-->
<!--                      {{childOptionItem.field_name}} <span v-if="childOptionItem.field_icon != undefined && childOptionItem.field_icon != null "v-html="getFieldIcon(childOptionItem.field_icon)"></span> <span v-if="childOptionItem.field_price > 0" style="float:right;"><del v-if="childOptionItem.originalPrice > childOptionItem.field_price">{{(childOptionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{(childOptionItem.field_price).toFixed(2)}}</span>-->
<!--                    </li>-->
<!--                  </ul>-->

<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
<!--            <div class="row"  style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-if="currentMerchantItem.disableMemo == undefined || currentMerchantItem.disableMemo == 0">-->
<!--              <div class="col-12 option-selection-title">-->
<!--                Memo (Please tell us if you have any food allergy)-->
<!--              </div>-->
<!--              <div class="col-12" style="padding-bottom: 10px;">-->

<!--                <textarea class="form-control" rows="2" v-model="optionSelectItem.memo"></textarea>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row" style="margin-top: 10px;margin-bottom: 10px; background-color: white;padding-bottom:20px;padding-top:20px;">-->
<!--              <div class="col-4 amount-chooser text-right">-->
<!--                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(-1)"><i class="fas fa-minus-circle"></i></span>-->
<!--              </div>-->
<!--              <div class="col-4 amount-chooser">-->
<!--                {{optionSelectItem.amount}}-->
<!--              </div>-->
<!--              <div class="col-4 amount-chooser text-left">-->
<!--                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(1)"><i class="fas fa-plus-circle"></i></span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row" v-if="optionSelectItem.pricePoints > 0 &&-->
<!--                            optionSelectItem.pointsUsed == 0 &&-->
<!--                            (order == false || order.pointsUsed == 0) &&-->

<!--                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > optionSelectItem.pricePoints">-->
<!--              <div class="col-12">-->
<!--                <button type="button" class="add-button redeem-button" v-on:click="redeemPoint()">Redeem {{optionSelectItem.pricePoints}} {{points.unitTitle}}s</button>-->
<!--              </div>-->

<!--            </div>-->
            <div class="row eemo-yellow eemo-btn fixed-bottom" style="padding-top:20px;padding-bottom: 20px; box-shadow: 0px -2px 20px 2px gray;" >
              <div class="col-12" v-on:click="addToOrder">
                Add £{{(optionSelectItem.totalPrice/100).toFixed(2)}}
              </div>
<!--              <div class="col-12" v-else v-on:click="closeTop">-->
<!--                <template v-if="type === 'delivery' && slots.length > 0">Delivery:<span  v-for="(slot, si) in slots"><span v-if="si > 0">, </span>{{slot.fromString}}~{{slot.toString}}</span></template>-->
<!--                <span v-else>Closed</span>-->

<!--              </div>-->
            </div>
            <!--          <div class="row" v-if="optionSelectItem.content.options != null && selectOrderItem.content.options.length > 0">-->


            <!--          </div>-->
          </div>
          <div class="float-back" v-on:click="closeTop" style="display: none;"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>


      <transition name="slide-fade">
        <div class="background-page level-3 eemo-gray h-100" v-if="setSelectItem != false">
          <div class="container h-100" style="overflow-y: scroll; padding-bottom: 100px;">

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-12" v-if="setSelectItem.imgs.length > 1" style="padding-bottom: 0px; display: flex; overflow-x: scroll; position: relative;">
                <img v-for="img in setSelectItem.imgs" class="selection-image" height="200px" style="border-radius: 10px; margin-left:10px;" :src="img"/>

              </div>
              <div class="col-12 single-image" v-else-if="setSelectItem.imgs.length == 1" style="padding-bottom: 0px;" v-bind:style="{backgroundImage: 'url(' + setSelectItem.imgs + ')'}">

              </div>
              <div class="col-12" v-else style="height: 70px;">

              </div>
              <div class="col-12" style="font-size: 10px; background-color:white;">
                Pictures may differ from original foods
              </div>
              <!--              <div class="col-12 option-title">-->
              <!--                {{optionSelectItem.publicMenuName}}-->
              <!--              </div>-->
              <div class="col-12 big-name text-left" style="background: white;">
                {{setSelectItem.publicMenuName}}
                <p v-if="setSelectItem.alcohol != undefined && setSelectItem.alcohol == true" class="alcohol" style="font-size: small;">
                  This is alcoholic product. You must be over 18.<br>
                  Staff will check your age and may ask your ID at <span>{{type=='table'?'serving':'food collection'}}</span>
                </p>
              </div>
              <div class="col-12 option-description" v-if="getMenuDescription(setSelectItem.menuId) !== ''">

                {{getMenuDescription(setSelectItem.menuId)}}
              </div>
              <div class="col-12 option-ingredients text-left" v-if="getMenuIngredients(setSelectItem.menuId) !== ''">
                <div class="option-section-title text-left">Ingredients</div>
                {{getMenuIngredients(setSelectItem.menuId)}}
              </div>
              <div style="position: absolute; left:15px;top:15px; background:yellow; width:40px;height: 40px;border-radius: 20px;line-height: 40px;" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
            </div>
            <div class="row option-selection-title">
              <div class="col-6">
                Basic
              </div>
              <div class="col-6 price">
                £{{(setSelectItem.price/100).toFixed(2)}}<span v-if="setSelectItem.originalPrice > setSelectItem.price">&nbsp;&nbsp;<del>£{{(setSelectItem.originalPrice/100).toFixed(2)}}</del></span>
              </div>

            </div>


            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(section, index) in setSelectItem.sections">
              <div class="col-12 option-selection-title">
                {{section.section_title}}
              </div>
              <div class="col-12">
                <ul class="list-group">
                  <template v-for="(selectProduct, pi) in section.products">
                    <div class="list-group-item option-item"
                         :key="'select-product-' + index + '-' + pi"
                         v-bind:class="{'set-selected': selectProduct.selected == true}"
                         v-on:click="toggleSetSection(index, pi)">
                      {{selectProduct.public_name != null && selectProduct.public_name.length > 0 ? selectProduct.public_name : selectProduct.name}}

                    </div>
                    <div class="set-product-option-container" v-if="selectProduct.selected == true">
                      <div v-for="(option, optionIndex) in selectProduct.options">

                        <div class="option-section-title" style="padding-left: 15px; text-align: left;">{{option.name}}</div>
                        <ul class="list-group">
                          <div class="list-group-item option-item"  v-for="(optionItem, optionItemIndex) in option.list"
                               :key="'option-' + index + '-' + optionItemIndex"
                               v-bind:class="{'selected': optionItem.selected == true}"
                               v-on:click="toggleSetSectionProductOption(index, pi, optionIndex, optionItemIndex)">
                            {{optionItem.field_name}}
                            <span v-if="optionItem.field_icon != undefined && optionItem.field_icon != null "v-html="getFieldIcon(optionItem.field_icon)"></span>
                            <span v-if="optionItem.field_price > 0 && (option.base_price == undefined || option.base_price == false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>
                            <span v-if="optionItem.field_price >= 0 && (option.base_price != undefined && option.base_price == true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </template>

                </ul>
              </div>
            </div>


            <!--            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(option, index) in optionSelectItem.options">-->
            <!--              <div class="col-12 option-selection-title">-->
            <!--                {{option.name}}-->
            <!--              </div>-->

            <!--              <div class="col-12">-->
            <!--                <ul class="list-group">-->
            <!--                  <div class="list-group-item option-item"  v-for="(optionItem, oi) in option.list"-->
            <!--                       :key="'option-' + index + '-' + oi"-->
            <!--                       v-bind:class="{'selected': optionItem.selected == true}"-->
            <!--                       v-on:click="toggleOption(index, oi)">-->
            <!--                    {{optionItem.field_name}}-->
            <!--                    <span v-if="optionItem.field_icon != undefined && optionItem.field_icon != null "v-html="getFieldIcon(optionItem.field_icon)"></span>-->
            <!--                    <span v-if="optionItem.field_price > 0 && (option.base_price == undefined || option.base_price == false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>-->
            <!--                    <span v-if="optionItem.field_price >= 0 && (option.base_price != undefined && option.base_price == true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>-->
            <!--                  </div>-->
            <!--                </ul>-->

            <!--              </div>-->

            <!--              <div style="width:100%;" v-if="option.children != undefined && option.children != null && option.children.length > 0 && isOptionSelected(option)" v-for="(co, ci) in option.children">-->
            <!--                <div class="col-12 option-name">-->
            <!--                  {{co.name}}-->
            <!--                </div>-->

            <!--                <div class="col-12" v-if="co.list != undefined && co.list.length > 0">-->
            <!--                  <ul class="list-group">-->
            <!--                    <li class="list-group-item option-item"  v-for="(childOptionItem, cci) in co.list"-->
            <!--                        :id="'option-selection-' + index + '-' + ci + '-' + cci"-->
            <!--                        :key="'option-' + index + '-' + ci + '-' + cci"-->
            <!--                        v-bind:class="{'selected': childOptionItem.selected == true}"-->
            <!--                        v-on:click="toggleOption(index, ci, cci)">-->
            <!--                      {{childOptionItem.field_name}} <span v-if="childOptionItem.field_icon != undefined && childOptionItem.field_icon != null "v-html="getFieldIcon(childOptionItem.field_icon)"></span> <span v-if="childOptionItem.field_price > 0" style="float:right;"><del v-if="childOptionItem.originalPrice > childOptionItem.field_price">{{(childOptionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{(childOptionItem.field_price).toFixed(2)}}</span>-->
            <!--                    </li>-->
            <!--                  </ul>-->

            <!--                </div>-->

            <!--              </div>-->
            <!--            </div>-->
            <div class="row"  style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-if="currentMerchantItem.disableMemo == undefined || currentMerchantItem.disableMemo == 0">
              <div class="col-12 option-selection-title">
                Memo (Please tell us if you have any food allergy)
              </div>
              <div class="col-12" style="padding-bottom: 10px;">

                <textarea class="form-control" rows="2" v-model="setSelectItem.memo"></textarea>
              </div>
            </div>
            <div class="row" style="margin-top: 10px;margin-bottom: 10px; background-color: white;padding-bottom:20px;padding-top:20px;">
              <div class="col-4 amount-chooser text-right">
                <span v-if="setSelectItem.pointsUsed == 0" v-on:click="setSelectionChangeAmount(-1)"><i class="fas fa-minus-circle"></i></span>
              </div>
              <div class="col-4 amount-chooser">
                {{setSelectItem.amount}}
              </div>
              <div class="col-4 amount-chooser text-left">
                <span v-if="setSelectItem.pointsUsed == 0" v-on:click="setSelectionChangeAmount(1)"><i class="fas fa-plus-circle"></i></span>
              </div>
            </div>
            <div class="row" v-if="setSelectItem.pricePoints > 0 &&
                            setSelectItem.pointsUsed == 0 &&
                            (order == false || order.pointsUsed == 0) &&

                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > setSelectItem.pricePoints">
              <div class="col-12">
                <button type="button" class="add-button redeem-button" v-on:click="redeemPoint()">Redeem {{setSelectItem.pricePoints}} {{points.unitTitle}}s</button>
              </div>

            </div>
            <div class="row eemo-yellow eemo-btn fixed-bottom" style="padding-top:20px;padding-bottom: 20px; box-shadow: 0px -2px 20px 2px gray;" >
              <div class="col-12" v-if="checkIfOpen() == true || preorder == true" v-on:click="addSetToOrder">
                Add £{{(setSelectItem.totalPrice/100).toFixed(2)}}
              </div>
              <div class="col-12" v-else v-on:click="closeTop">
                <template v-if="type === 'delivery' && slots.length > 0">Delivery:<span  v-for="(slot, si) in slots"><span v-if="si > 0">, </span>{{slot.fromString}}~{{slot.toString}}</span></template>
                <span v-else>Closed</span>

              </div>
            </div>
            <!--          <div class="row" v-if="optionSelectItem.content.options != null && selectOrderItem.content.options.length > 0">-->


            <!--          </div>-->
          </div>
          <div class="float-back" v-on:click="closeTop" style="display: none;"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>


      <transition name="vertical">
        <div class="background-page level-3 popup-background" style="padding-top:100px" v-if="order != false && showBasket == true">
          <div class="floating-container" style="background-color:white">
            <div class="container h-100" style="overflow-x: scroll; padding-top:10px; padding-bottom: 10px;">
              <div class="row" style="padding-top:20px;">
                <div class="col-8 basket-title text-left">
                  <h3>Order List</h3>
                </div>
                <div class="col-4 text-right">

                  <h3><span v-on:click="closeTop"><i class="fas fa-times"></i></span></h3>
                </div>
              </div>

              <div class="row">

                <div class="col-12 text-left " style="margin-top:10px;">
                  <table class="table">
                    <tbody v-if="order.list != undefined && order.list.length > 0">
                    <tr v-for="(item, index) in order.list" v-if="(item.tags == null || item.tags !== UUID) && showMine == false" v-bind:class="{'eemo-yellow':item.state == 0, 'wait-accept': item.state >= 1 && item.state < 4}">
                      <td style="width: 50%;"><div v-html="getOrderItemName(index)"></div><span v-if="item.memo != undefined && item.memo.length > 0"><br>*{{item.memo}}</span></td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(-1, index)"><i class="fas fa-minus-circle"></i></span></td>
                      <td class="text-center">{{item.amount}}</td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(1, index)"><i class="fas fa-plus-circle"></i></span></td>
                      <td class="text-right">{{Number(item.totalPrice/100).toFixed(2)}}</td>
                      <td class="text-right">
                        <span v-if="item.state < 1" v-on:click.stop="confirmDeleteItem(index)"><i class="fas fa-trash"></i></span>
                        <span v-else-if="item.state == 1"><div class="lds-dual-ring"></div></span>
                        <span v-else-if="item.state >= 4"><i class="fas fa-check"></i></span>
                      </td>

                    </tr>
                    </tbody>
                    <tbody v-if="order.list != undefined && order.list.length > 0">
                    <tr v-for="(item, index) in order.list"  v-if="item.tags != null && item.tags === UUID" v-bind:class="{'eemo-yellow':item.state < 4, 'wait-accept': item.state >= 1 && item.state < 4}">
                      <td style="width: 50%;"><div v-html="getOrderItemName(index)"></div><span v-if="item.memo != undefined && item.memo.length > 0"><br>*{{item.memo}}</span></td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(-1, index)"><i class="fas fa-minus-circle"></i></span></td>
                      <td class="text-center">{{item.amount}}</td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(1, index)"><i class="fas fa-plus-circle"></i></span></td>
                      <td class="text-right">{{Number(item.totalPrice/100).toFixed(2)}}</td>
                      <td class="text-right">
                        <span v-if="item.state < 1" v-on:click.stop="confirmDeleteItem(index)"><i class="fas fa-trash"></i></span>
                        <span v-else-if="item.state == 1"><div class="lds-dual-ring"></div></span>
                        <span v-else-if="item.state >= 4"><i class="fas fa-check"></i></span>
                      </td>

                    </tr>
                    </tbody>
<!--                    <tr class="text-right" v-if="Number(order.totalPrice) != Number(order.totalDue)">-->
<!--                      <td colspan="4">Sub Total</td>-->
<!--                      <td>{{Number(order.totalPrice/100).toFixed(2)}}</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right" v-if="order.serviceCharge > 0">-->
<!--                      <td colspan="4">Service Charge ({{Number(order.serviceChargeRate/100).toFixed(1)}}%)</td>-->
<!--                      <td>{{Number(order.serviceCharge/100).toFixed(2)}}</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right" style="font-weight: bold; color:red;" v-if="promotion != false && order.discountAmount > 0">-->
<!--                      <td colspan="4">{{promotion.title}}</td>-->
<!--                      <td>{{Number(order.discountAmount/100).toFixed(2)}}</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right" style="font-weight: bold; color:red;" v-if="order.pointsUsed > 0">-->
<!--                      <td colspan="3">Redeemed</td>-->
<!--                      <td colspan="2">{{order.pointsUsed}} {{points.unitTitle}}s</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right" v-if="type=='table' && showMine == true">-->
<!--                      <td colspan="4">My Total</td>-->
<!--                      <td>{{myTotal()}}</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right" v-if="type==='delivery'">-->
<!--                      <td colspan="4">Delivery Charge</td>-->
<!--                      <td>{{Number(order.deliveryCharge/100).toFixed(2)}}</td>-->
<!--                    </tr>-->
<!--                    <tr class="text-right total-price">-->
<!--                      <td colspan="4"><span v-if="type==='table' && showMine == true">Table Total</span><span v-else>Total</span></td>-->
<!--                      <td>{{Number(order.totalDue/100).toFixed(2)}}</td>-->
<!--                    </tr>-->

<!--                    <tr class="text-right" v-if="type==='delivery' && order.totalDue < minOrder">-->
<!--                      <td colspan="4">Min Order</td>-->
<!--                      <td>{{Number(minOrder/100).toFixed(2)}}</td>-->
<!--                    </tr>-->

<!--                    <tr class="text-right" v-if="points != false && order.points > 0">-->
<!--                      <td colspan="4">{{points.unitTitle}} you earn</td>-->
<!--                      <td>{{order.points}}</td>-->
<!--                    </tr>-->
                  </table>

                </div>

                <template >
                  <div class="col-12 text-left basket-section" v-if="type === 'takeaway'">
                    <span v-if="type=='delivery'">Delivery time</span><span v-if="type==='takeaway'">Pickup Time</span>
                  </div>
                  <div class="col-12 text-left" v-if="type === 'takeaway' || (type === 'delivery' && currentMerchantItem.boriumDelivery == 0 && acceptCard == true)">
                    <select class="form-control" v-model="order.pickupTime">
                      <option v-for="slot in timeSlots" :value="slot">{{slot}}</option>
                    </select>
                    <!--                  <vue-timepicker format="HH:mm" :minute-interval="15" v-model="order.pickupTime"></vue-timepicker>-->
                  </div>
                  <div class="col-12 text-left" v-if="type === 'delivery'">
                    <strong>Estimated Delivery Time: {{order.pickupTime}}</strong>
                  </div>

                  <div class="col-12 text-left basket-section" v-if="type=='delivery'" style="display: none;">
                    Post Code
                    <input type="text" class="form-control" v-model="order.postCode" disabled/>
                  </div>
                  <div class="col-12 text-left basket-section" v-if="type=='delivery'">
                    Address <span> ({{getDistanceString(distance)}})</span> <span style="float:right;" v-on:click="searchAddress" >Change</span>
                    <textarea rows="2" class="form-control" v-model="order.address" disabled/>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Nick Name (Required)
                    <input type="text" class="form-control" v-model="order.name"/>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Phone Number (Required)
                    <input type="tel" class="form-control" v-model="order.phoneNumber"/>
                  </div>
                  <div class="col-12 text-left basket-section" v-if="type === 'delivery'">
                    Delivery Option
                    <select class="form-control" v-model="order.deliveryOption">
                      <option value="Leave at door">Leave at door</option>
                      <option value="Meet at door">Meet at door</option>
                      <option value="Meet outside">Meet outside</option>
                    </select>
                  </div>
                  <div class="col-12 text-left basket-section" v-if="type === 'delivery'">
                    Delivery Instruction to rider
                    <textarea class="form-control" rows="2" v-model="order.deliveryInstruction"></textarea>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Email <span class="basket-section-description">(If you wish to receive update of your order)</span>
                    <input type="text" class="form-control" v-model="order.email"/>
                  </div>
                </template>

              </div>

              <template>
                <div class="row" v-bind:class="{'fixed-bottom': type=='table'}">
                  <template>
                    <div v-if="acceptCash == true && (cashLimit == 0 || order.totalDue < cashLimit*100)" class="col-12" v-bind:class="{'col-12': acceptCash == false}" style="padding-top:10px;">
                      <button class="form-control btn btn-primary" v-on:click="placeOrder('tillCash')">{{cashBtnTitle}}</button>
                    </div>
                    <div v-if="teyaPaymentReady === true || dojoPaymentReady === true || acceptStripe == true" class="col-12">
                      <CardSchemeLogos/>
                    </div>
                    <div v-if="teyaPaymentReady === true" class="col-12" style="padding-top:10px;">
                      <button class="teya-pay-button" v-on:click="placeOrder('teya')">PAY BY CARD</button>
                    </div>
                    <div v-else-if="dojoPaymentReady === true" class="col-12" style="padding-top:10px;">
                      <button class="form-control dojo-pay-button" v-on:click="placeOrder('dojo')">Pay by card</button>
                    </div>
                    <div v-else-if="acceptStripe == true" class="col-12" style="padding-top:10px;">
                      <button class="form-control btn btn-primary" v-on:click="placeOrder('stripe')">{{stripeBtnTitle}}</button>
                    </div>

                  </template>
                </div>

              </template>
              <div v-if="(type === 'takeaway' || type === 'delivery') && currentMerchantItem != false" style="margin-top: 16px;">
                <Bottom :item="currentMerchantItem"></Bottom>
              </div>
            </div>
          </div>
          <div class="float-back" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-popup popup-background" v-if="showTableOrderConfirm == true">
          <div class="popup-container">
            <div class="container">
              <div class="row">
                <div class="col-12" style="padding-bottom: 20px; font-weight: bold">
                  Please let us know if you have any Allergy and inquiry
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  Is everyone on your table ready to place order?<br>Placing order together will help our kitchen prepare better.
                </div>

              </div>
              <div class="row" style="margin-top:20px;">
                <div class="col-6 dialog-btn cancel-btn" v-on:click="waitForTableOrder">
                  I will wait
                </div>
                <div class="col-6 dialog-btn confirm-btn" v-on:click="placeTableOrder">
                  Yes, Place Order
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-4 popup-background" v-if="showHistory == true && orderHistory != null && orderHistory.length > 0" >
          <div class="floating-container eemo-gray">
            <div id="history-container" class="container h-100" style="overflow-x: scroll; padding-top:10px; padding-bottom: 10px;">
              <div class="row">
                <div class="col-12 big-name">
                  <span style="float:left" v-on:click="closeTop"><i class="fas fa-arrow-left"></i></span>Your Orders
                </div>
              </div>
              <div class="row" v-for="(h, index) in orderHistory" :id="'history-item-' + h.id">
                <div class="col-12">
                  <div class="order-item-container" :class="'order-status-' + h.state">
                    <div class="order-item-merchant">#{{h.id}} {{h.merchantName}}</div>
                    <template v-if="h.state >= 0">
                      <div class="order-item-merchant-info" v-if="h.merchantInfo != undefined && h.merchantInfo != null">
                        <div v-if="h.merchantInfo.merchantAddress != undefined && h.merchantInfo.merchantAddress != null" v-html="h.merchantInfo.merchantAddress.replace(/\n/g, '<br>')"></div>
                        <div v-if="h.merchantInfo.contact != undefined && h.merchantInfo.contact != null"><a :href="'tel:'+ h.merchantInfo.contact">{{h.merchantInfo.contact}}</a></div>
                      </div>
                      <hr>
                      <div class="order-item-title">Order Time: {{new Date(h.createdTimestamp).toLocaleString()}}</div>
                      <p v-if="h.state > 1 && h.state < 5 && h.pickupTime != null && h.pickupTime.length > 0"><strong>Pickup Time:</strong> {{h.pickupTime}}</p>
                      <div class="order-item-status"><strong>Status</strong></div>
                      <div class="lds-ring" v-if="h.state == 0"><div></div><div></div><div></div><div></div></div>
                      <div v-html="getOrderStateString(h.state, h.recordType, h.merchantName)"></div>
                      <qrcode-vue v-if="h.salesReference != null && h.salesReference.length == 12 && h.state >= 4 && h.state < 6":value="h.salesReference" :size="150" level="H"></qrcode-vue>
                      <div class="order-item-message-to-confirm" v-if="h.state == 1">

                        <p>{{h.message}}</p>
                        <button class="btn btn-primary" v-on:click="acceptChange(h)">Accept</button>
                        <button class="btn btn-danger" v-on:click="cancelChange(h)">Cancel</button>
                      </div>

                      <div class="order-item-description">
                        <div class="order-section-title">Order details</div>
                        <table class="table">
                          <tr v-for="order in h.list">
                            <td>{{getHistoryOrderItemName(order)}} x {{order.amount}}<span v-if="order.memo != null && order.memo.length > 0"><br>Memo:{{order.memo}}</span></td>
                            <td class="text-right">£{{(order.totalPrice/100).toFixed(2)}}</td>
                          </tr>
                          <tr v-if="h.deliveryCharge > 0">
                            <td>Delivery Charge</td>
                            <td class="text-right">£{{(h.deliveryCharge/100).toFixed(2)}}</td>
                          </tr>
                        </table>

                      </div>
                      <div v-if="h.memo != null && h.memo.length > 0">Memo: {{h.memo}}</div>


                      <div v-if="h.postCode != null && h.postCode.length > 0">{{h.postCode}}</div>
                      <div v-if="h.address != null && h.address.length > 0" v-html="h.address.replace(/\n/g, '<br>')"></div>
                      <div class="order-item-price">£{{((h.totalDue/100).toFixed(2))}}</div>
                      <div v-if="points != false && h.points > 0">
                        {{h.points}} {{points.unitTitle}}
                      </div>
                    </template>
                    <template v-else>
                      <div v-if="h.state < 0 && (h.paymentMethod === 'webCard' || h.paymentMethod === 'paymentSense' || h.paymentMethod === 'paymentsense' || h.paymentMethod === 'dojo')" style="color:red;"><strong>Payment Failed (Code: {{h.state}})</strong></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="float-back" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-3 popup-background" style="padding-top:100px" v-if="newPreOrder != false">
          <div class="floating-container" style="background-color:white">
            <div class="container h-100" style="overflow-x: scroll; padding-top:10px; padding-bottom: 10px;">
              <div class="row">
                <div class="col-12">
                  <h3>New PreOrder Session</h3>
                  <h4>{{currentMerchantItem.title}}</h4>
                  <p>Please enter your name or group name and contact number</p>
                </div>
              </div>
              <div class="row" style="margin-top:50px;">
                <div class="col-12">
                  <input class="form-control" type="text" v-model="newPreOrder.name" placeholder="name / group name"/>
                </div>
              </div>

              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <input class="form-control" type="text" v-model="newPreOrder.phoneNumber" placeholder="Phone number"/>
                </div>
              </div>

              <div class="row" style="margin-top:100px;">
                <div class="col-12">
                  <button class="btn btn-success" v-on:click="createNewPreSession">CREATE SESSION</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="background-page level-popup popup-background" v-if="showPostCodeInput == true">
        <div class="address-finder-container">
          <div class="container" style="position: sticky; top:0; z-index:2; background-color: #B5DBFF; padding-bottom:10px;">
            <div class="row">
              <div class="col-12 text-left" style="font-size: 20px; height: 60px; line-height:60px;">
                Delivery Address
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <input type="text" class="form-control text-center" v-model="postCodeSearchWord" placeholder="POST CODE"/>
              </div>
              <div class="col-6">
                <button class="btn btn-primary form-control" v-on:click="getAddressCandidates"><i class="fas fa-search"></i> Find</button>
              </div>
            </div>

            <div class="row" v-if="selectedCandidate != null && selectedCandidate.length > 0" style="">
              <div class="col-12 text-left" style="padding-top:10px;">
                <div style="border: 1px solid gray; padding:10px; border-radius: 5px; background-color: #D1E9FF;">
                  {{selectedCandidate}}
                </div>
              </div>
              <div class="col-12 text-left" style="padding-top:10px; padding-bottom:10px;">
                <button class="btn btn-dark" v-on:click="processAddress">Use This Address</button>
              </div>
            </div>
          </div>
          <div class="container" v-if="addressCandidates.length > 0">
            <div class="row">
              <div class="col-12 text-left" v-for="can in addressCandidates" v-bind:key="'shop-postcode-candidate-' + can.summaryline">
                <div class="address-candidate" v-on:click="selectCandidate(can.summaryline)">
                  {{can.summaryline}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="background-page level-popup popup-background" v-if="false">
        <div class="popup-container">
          <div class="container">
            <div class="row">
              <div class="col-12 text-left" style="margin-top: 20px;">

                <h6>Please search your address for delivery</h6>

              </div>
              <div class="col-12" style="margin-top:20px;">
                <vue-google-autocomplete
                  v-if="address == false"
                  id="address-searcher"
                  :country="['uk']"
                  classname="form-control"
                  placeholder="Type Road Name"
                  v-on:placechanged="getAddressData"
                >
                </vue-google-autocomplete>

              </div>
              <div class="col-12 text-left" style="margin-top:20px;" v-if="address != false">
                {{address.text}}
                <!--                <div class="col-12 text-left" style="margin-top: 20px;">-->
                <!--                  Street/Flat Number-->
                <!--                  <input type="text" class="form-control" v-model="address.streetNumber"/>-->
                <!--                </div>-->
                <!--                <div class="col-12 text-left">-->
                <!--                  <div class="address-line" v-for="(ac, index) in address.address_components" v-if="address.streetName != '' && >-->
                <!--                    {{ac.long_name}}-->
                <!--                  </div>-->
                <!--                </div>-->



              </div>
              <!--              <div class="col-12" style="margin-top: 20px;">-->
              <!--                <input type="text" class="form-control text-center" v-model="postCode" @input="postCode = $event.target.value.toUpperCase()"/>-->
              <!--              </div>-->

            </div>
            <div class="row" v-if="address != false">
              <div class="col-6" style="margin-top: 40px;">
                <div  v-on:click="startAddressSearch" class="search-btn" style=""><i class="fas fa-search"></i> Search</div>
              </div>
              <div class="col-6" style="margin-top: 40px;">
                <div class="search-btn" style="background-color: blue;" v-on:click="onPostCodeEntered">OK</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="margin-top: 40px;">
                <span v-if="minOrder > 0">Minimum Order is £{{(minOrder/100).toFixed(2)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="background-page level-popup" style="background-color: rgba(0,0,0,0.7);" v-if="advertImage != false" v-on:click="closeAdvert">
        <div class="popup-container" style="padding:0">
          <img :src="advertImage" style="width: 100%" v-on:click.stop="doNothingOnClick"/>
          <div style="width: 100%;height: 50px; line-height: 50px; background: white;" class="text-center" v-on:click.stop="closeAdvert">
            CLOSE
          </div>

        </div>
      </div>
      <div class="background-page level-popup popup-background" v-if="popup.show == true" v-on:click="clickedOnBackground">
        <div class="popup-container">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h5>{{popup.title}}</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p v-html="popup.message"></p>
              </div>
            </div>
            <div class="row">
              <div class="col-6"  v-if="popup.noBtnTitle.length > 0" v-on:click.stop="clickedOnNo">
                {{popup.noBtnTitle}}
              </div>
              <div class="col-6"  v-if="popup.yesBtnTitle.length > 0" v-on:click.stop="clickedOnYes">
                {{popup.yesBtnTitle}}
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="background-page level-popup popup-background" v-if="redeemables != false && redeemables.length > 0" v-on:click="closeRedeemManual">
        <div class="popup-container">
          <div class="container text-left">
            <div class="row">
              <div class="col-12">
                <h5><strong>You have {{userPoint.balance}} {{points.unitTitle}}s!!!</strong></h5>
              </div>
            </div>
            <div class="row">
              <hr>
              <div class="col-12">
                Look at menu with {{points.unitTitle}}s next to price
                <div style="border:1px solid grey;margin-top:10px;margin-bottom: 10px;">
                  <img src="/static/img/redeemable.png" width="100%;"/>
                </div>
              </div>
              <div class="col-12">
                Select the menu and click "Redeem" button
                <div style="border:1px solid grey;margin-top:10px;margin-bottom: 30px;">
                  <img src="/static/img/redeem.png" width="100%;"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button class="btn btn-dark form-control" v-on:click.stop="closeRedeemManual">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-page level-popup popup-background" v-if="stripeCardPayment != false">
      <div class="popup-container">
        <div class="container">
          <div class="row">
            <form>
              <input type="text" placeholder="Credit Card #" v-model="stripeCardPayment.cardNumber">
              <input type="text" placeholder="Expiration Month" v-model="stripeCardPayment.expMonth">
              <input type="text" placeholder="Expiration Year" v-model="stripeCardPayment.expYear">
              <input type="text" placeholder="CVC" v-model="stripeCardPayment.cvc">
              <button v-on:click="chargeCreditCard">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-background" v-if="isLoading">
      <div class="wrapper">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>{{loadingMessage}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from "../api/event-bus";
  import VueTimepicker from 'vue2-timepicker';
  import 'vue2-timepicker/dist/VueTimepicker.css';
  import {millisToDate, millisToReadable} from "../api/utils";
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import Bottom from "./Bottom";
  import CardSchemeLogos from "./CardSchemeLogos";
  require('@/assets/css/styles.css')
  require('@/assets/css/transitions.css')
  const axios = require('axios');
  import {
    getMerchant,
    getMerchantMenus,
    getTableMerchant,
    submitOrder,
    getDojoPaymentConfigStatus,
    getMyOrder,
    updateMyOrder,
    getDistance,
    getDeliveryAddresses,
    getUserPoint,
    getTeyaPaymentConfigStatus,
    updatePaymentItem,
    addItemsToTable,
    getTablePendingOrder,
    submitTableOrder,
    deleteTableItem,
    updateTableItem,
    submitLog,
    getPreOrder,
    createNewPreOrder,
    addPreOrderItem,
    updatePreOrder,
    deletePreOrderItem
  } from "../api/borium";
  import QrcodeVue from 'qrcode.vue'
  import { Slider, SliderItem } from 'vue-easy-slider'
  import {millisToHM} from "../api/utils";
  import Router from '../router';
  export default {
    name: "Shop",
    data() {
      return {
        currentPath:'',
        basePath:'',
        animDuration: 300,
        dojoPaymentReady: false,
        canTakeOrder:false,
        // connectE: null,
        mqtt:null,
        topics:[],
        images:[],
        mqttDisconnect: false,

        currentMode: 0, //테이크아웃: 0, 방문예약: 1, 자동주문예약: 2, QR코드주문: 3

        merchantId:0,
        tableItem: false,
        tableTags:[],
        currentMerchantItem: false, //매장정보

        bookingItem: false, //예약상세

        orderItem: false, //주문상세


        merchants:[],
        order:false,
        selectOrderItem: false,
        optionSelectItem: false,
        setSelectItem: false,


        popup: {
          show:false,
          title:"",
          message:'',
          noBtnTitle:'',
          yesBtnTitle:'',
          noCb:null,
          yesCb:null,
          bgCb:null,

        },
        orderHistory:[],
        type:'dinein',
        showBasket: false,
        orderItemToPay: false,
        showHistory: false,
        timeSlots:[],
        preScrollPosition: 0,
        postCode:'',
        showPostCodeInput:false,
        distance:0,
        openingTime:false,
        deliveryTime:false,
        isOpen: false,
        slots: [],
        isShopOpen:false,
        shopSlots:[],
        interval:15,
        taDelay:30,
        deliveryDelay:45,
        deliveryTimePerMile:5,
        delayTime:0,
        lastOrder: 30,
        lastDeliveryOrder:45,
        additionalDelayPrice: 10000,
        additionalDelay:10,
        minOrder:0,
        acceptCash:true,
        acceptCard:false,
        cashLimit:0,
        acceptStripe: false,
        teyaPaymentReady: false,
        cashBtnTitle:'CASH',
        cardBtnTitle:'CARD',
        stripeBtnTitle:'CARD',
        enableTakeaway: true,
        enableDelivery: true,
        promotions:[],
        promotion:false,
        points:false,
        userPoint:false,
        cardPayItem:false,

        distanceChargeList:[],
        deliveryPriceByDistance:false,
        deliveryChargeType: 0,
        deliveryChargeAmount: 0,
        freeDeliveryOver: 0,
        deliveryBaseCharge: 0,
        deliveryChargePerMilePrice: 0,
        limitType: 'distance',

        isLoading:false,
        loadingMessage:'',
        position: {
          lat:0,
          lng:0,
        },
        UUID:'',
        count:0,
        showMine:false,
        showTableOrderConfirm: false,
        toLeave: false,

        advertImage:false,

        redeemables:[],
        redeemableManualSeen:false,
        stripeCardPayment: false,
        stripe:false,

        lastCount:0,

        address:false,
        distanceOk:false,
        postCodeSearchWord:'',
        addressCandidates:[],
        selectedCandidate:'',
        showLog:false,
        postCodeList:[],

        preorder:false,
        orderId:0,

        newPreOrder:false,
      }
    },
    components: {
      VueTimepicker,
      QrcodeVue,
      Slider,
      SliderItem,
      Bottom,
      CardSchemeLogos,
      VueGoogleAutocomplete
    },
    // beforeRouteUpdate(to, from, next) {
    //   // console.log("beforeRouteUpdate");
    //   // console.log("beforeRouteUpdate");
    //   // if(this.$data.toLeave == false) {
    //   //   if (this.backPressed() == true) {
    //   //     next(false);
    //   //   } else {
    //   //     next();
    //   //   }
    //   // }
    // },
    // beforeRouteLeave(to, from, next) {
    //   // console.log("beforeRouteUpdate");
    //   // if(this.$data.toLeave == false) {
    //   //   if (this.backPressed() == true) {
    //   //     console.log("back key handled");
    //   //     next(false);
    //   //   } else {
    //   //     console.log("move to home");
    //   //     next();
    //   //   }
    //   // }
    // },
    created() {
      //console.log("created");

      this.$data.currentPath = this.$route.fullPath;
      this.$data.basePath = this.$route.fullPath;
      // console.log("base path");
      // console.log(this.$data.basePath);
      // console.log("URL: " + window.location.host)
      registerBackKeyHandler(this.backPressed);
      EventBus.$off('backPressed', this.backPressed);
      EventBus.$on('backPressed', this.backPressed);
      EventBus.$emit("modeChanged", 1);

      this.connect();
    },
    destroyed() {
      // console.log("Destoryed");
      this.disconnect();
    },
    mounted() {
      // registerBackKeyHandler(this.backPressed);

      this.getUUID();
      this.updatePage();
      $("#nav-top").addClass("transparent-background");
      // const plugin = document.createElement("script");
      // plugin.setAttribute(
      //   "src",
      //   "https://web.e.test.connect.paymentsense.cloud/assets/js/client.js"
      // );
      // plugin.async = true;
      // document.head.appendChild(plugin);
    },
    // beforeDestroy() {
    //   // console.log("breforeDestroy");
    //   registerBackKeyHandler(false);
    //   // registerBackKeyHandler(false);
    //   // document.removeEventListener("backbutton", this.backPressed);
    //   EventBus.$off('backPressed', this.backPressed);
    //   this.disconnect();
    // },
    watch: {
      $route() {
        // console.log("route changed");
        if(this.$data.basePath === this.$route.fullPath) {
          this.backPressed();
        }
        // this.updatePage();
      },
      'order.memo': function (newVal, oldVal) {
        if (this.$data.order == false) {
          return;
        }
        if (newVal.includes('"') || newVal.includes("'")) {
          this.$data.order.memo = newVal.replace('"', '').replace("'", "");
          window.alert("Cannot accept special characters")
        }
        var ranges = [
          '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
        ];
        if(this.$data.order.memo.match(ranges.join('|'))) {
          window.alert("Emoji cannot be used");
          var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
          this.$data.order.memo = this.$data.order.memo.replace(regex, '');
        }

      },
      'optionSelectItem.memo': function (newVal, oldVal) {
        if (this.$data.optionSelectItem == false) {
          return;
        }
        if (newVal.includes('"') || newVal.includes("'")) {
          this.$data.optionSelectItem.memo = newVal.replace('"', '').replace("'", "");
          window.alert("Cannot accept special characters")
        }
        var ranges = [
          '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
        ];
        if(this.$data.optionSelectItem.memo.match(ranges.join('|'))) {
          window.alert("Emoji cannot be used");
          var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
          this.$data.optionSelectItem.memo = this.$data.optionSelectItem.memo.replace(regex, '');
        }
      }
    },
    methods:{
      startAddressSearch: function() {
        this.$data.address = false;
      },
      refreshDojoPaymentReady: function() {
        var self = this;
        var m = this.$data.currentMerchantItem;
        if (!m || !m.merchantId) {
          this.$data.dojoPaymentReady = false;
          return;
        }
        getDojoPaymentConfigStatus(m.merchantId)
          .then(function(cfg) {
            self.$data.dojoPaymentReady = !!(cfg && cfg.success && cfg.item && cfg.item.ready === true);
          })
          .catch(function() {
            self.$data.dojoPaymentReady = false;
          });
      },
      refreshTeyaPaymentReady: function() {
        var self = this;
        var m = this.$data.currentMerchantItem;
        if (!m || !m.merchantId) {
          this.$data.teyaPaymentReady = false;
          return;
        }
        getTeyaPaymentConfigStatus(m.merchantId)
          .then(function(cfg) {
            self.$data.teyaPaymentReady = !!(cfg && cfg.success && cfg.item && cfg.item.ready === true);
          })
          .catch(function() {
            self.$data.teyaPaymentReady = false;
          });
      },

      getAddressData: function (addressData, placeResultData, id) {
        // console.log("address data " + addressData);
        // console.log(addressData);
        // console.log(placeResultData);
        this.$data.address = placeResultData;

        // console.log("address now " + this.$data.address);
        // console.log(this.$data.address);
        if(addressData.latitude != undefined) {
          this.$data.address.lat = addressData.latitude;
        }
        if(addressData.latitude != undefined) {
          this.$data.address.lat = addressData.latitude;
        }
        if(addressData.postal_code != undefined) {
          this.$data.address.postCode = addressData.postal_code;
        } else {
          this.$data.address.postCode = '';
        }
        if(addressData.street_number != undefined) {
          this.$data.address.streetNumber = addressData.street_number;
        } else {
          this.$data.address.streetNumber = '';
        }
        if(addressData.route != undefined) {
          this.$data.address.route = addressData.route;
        } else {
          this.$data.address.route = '';
        }



        let el = document.getElementById("address-searcher");
        if(el != null && el != undefined) {
          // console.log("Address " + el.value);
          this.$data.address.text = el.value;
        }


      },
      getUUID: function() {
        if(localStorage.getItem("UUID") == null) {
          let uuid = new Date().getTime();
          localStorage.setItem("UUID", uuid);
        }
        this.$data.UUID = localStorage.getItem("UUID");
      },
      onCatClicked: function(index) {
        let catDiv = document.getElementById("cat-" + index);
        if(catDiv != null) {
          // console.log(catDiv.offsetLeft);
          let container = document.getElementById("cat-container");
          $("#cat-container").animate({scrollLeft : catDiv.offsetLeft -15}, 300);
          // container.scrollLeft = catDiv.offsetLeft -15;
        }

        let id = "category-title-" + this.$data.currentMerchantItem.categories[index].id;


        let containerDiv = document.getElementById(id);
        // console.log("offset top " + containerDiv.offsetTop);
        let diff = 0;
        // if(containerDiv.offsetTop > 325) {
        diff = 300;
        // }
        if(containerDiv != null) {
          $("#menu-page").animate({scrollTop : containerDiv.offsetTop + diff}, 300);
          // containerDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // console.log("scroll");
        }


      },
      registerBackHandler: function() {
        let self = this;
        // console.log("register back handler");
        this.$router.beforeEach((to, from, next) => {
          // ...
          // console.log("router guard");
          if(self.backPressed() == true) {
            next(false);
          } else {
            next('/home');
          }
        })
      },
      deregisterBackHanlder: function() {
        // console.log("Deregister back handler");
        // let self = this;
        // this.$router.beforeEach((to, from, next) => {
        //   console.log("unregisterRouterGuard")
        //   self.backPressed()
        //
        //   next()
        // })
      },
      getHistory: function() {
        // console.log("getHistory");
        if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
          let self = this;
          getMyOrder(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
            .then(function(data) {
              // console.log("my order list ");
              // console.log(data);
              if(data.success == true) {
                for(let i = 0 ; i < data.item.length ; i++) {
                  // console.log(data.item[i])
                  if(data.item[i].title != null && data.item[i].title.length > 0) {
                    data.item[i].merchantInfo = JSON.parse(data.item[i].title);
                  }
                }
                self.$data.orderHistory = data.item;

              }
            })
            .catch(function(err) {
              // console.log(err);
              // if(err.response != undefined) {
              //   console.log(err.response);
              // }
            })
          this.subscribe(localStorage.getItem("tel"));
        } else {
          // console.log("getHistory no tel");
        }


      },
      updatePage: function() {
        let self = this;
        // console.log("update page");
        // console.log(this.$route);
        if(this.$route.params.hasOwnProperty('id') || this.$route.query.hasOwnProperty('id')) {
          if (this.$route.params.hasOwnProperty('id')) {
            // console.log("Params " + this.$route.params.id);
            this.$data.merchantId = this.$route.params.id;
          } else if (this.$route.query.hasOwnProperty('id')) {
            this.$data.merchantId = this.$route.query.id;
            // console.log("Query " + this.$route.query.id);
          }
        }
        getMerchant(this.$data.merchantId)
          .then(function(data) {
            // let nowTime = new Date().getTime();
            // console.log("response took " + (nowTime - fromTime));
            if(data.success == true) {
              // console.log("Merchant Response");
              // if(data.table != undefined) {
              //   self.$data.tableItem = data.table;
              // }
              self.merchantSelected(data.item);
              // console.log("call gethistory")
              // self.getHistory();
            } else {
              // console.log("Failed to get merchant " + data.message)
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
      },
      toggleMyOrder: function() {
        this.$data.showMine = !this.$data.showMine;
      },
      closeTop: function() {
        // console.log("close top");
        // if(this.$data.currentPath !== this.$data.basePath) {
        this.$router.go(-1);
        // }
      },
      backPressed: function(fromNav = false) {
        // console.log("backPressed " + this.$data.optionSelectItem);
        // console.log("backPressed on Restaurant");
        // if($("#basket-table").length > 0 && $("#basket-table").hasClass("show")) {
        //   $("#basket-table").removeClass("show");
        //   return;
        // }

        if(this.$data.showHistory == true) {
          this.$data.showHistory = false;
          // console.log("backPressed on Restaurant hide history");
          // unregisterRouterGuard();
          //this.deregisterBackHanlder();
          return true;
        }
        if(this.$data.showBasket == true) {
          this.$data.showBasket = false;
          // console.log("backPressed on Restaurant hide basket");
          //this.deregisterBackHanlder();
          return true;
        }
        if(this.$data.setSelectItem != false) {
          // console.log("backPressed on Restaurant hide option");
          this.$data.setSelectItem = false;
          //this.deregisterBackHanlder();
          return true;
        }
        if(this.$data.optionSelectItem != false) {
          // console.log("backPressed on Restaurant hide option");
          this.$data.optionSelectItem = false;
          //this.deregisterBackHanlder();
          return true;
        }
        // if(this.$data.currentMerchantItem != false) {
        //   this.$data.currentMerchantItem = false;
        //   return;
        // }
        // if(fromNav == true) {
        //   // Router.push('/home');
        //   history.go(-1)
        //   return false;
        // }
        // Router.push('/home?type=' + this.$data.type);
        // console.log("backPressed on Restaurant return false");
        // history.go(-1);
        this.$data.toLeave = true;
        return false;
      },
      getUserPoint: function() {
        this.$data.userPoint = false;
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return;
        }
        if(localStorage.getItem("tel") == null || localStorage.getItem("tel").length < 11) {
          return;
        }
        let self = this;
        // console.log("getUserPoint")
        getUserPoint(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
          .then(function(data) {
            // console.log("userPoint Res");
            // console.log(data);
            if(data.success == true) {
              self.$data.userPoint = data.item;
              self.checkPointsUsable();
            }
          })
          .catch(function(err) {

          })
      },
      checkPointsUsable: function() {
        // console.log("check Points Usable");
        this.$data.redeemables = [];
        if(this.$data.redeemableManualSeen == true) {
          // console.log("check Points Usable return");
          return;
        }
        let redeemables = [];
        if(this.$data.userPoint != false && this.$data.userPoint.balance > 0) {
          for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
            if(this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
                if(this.$data.currentMerchantItem.categories[i].list[j].pricePoints > 0 &&
                  this.$data.currentMerchantItem.categories[i].list[j].pricePoints < this.$data.userPoint.balance) {
                  let menuName = this.$data.currentMerchantItem.categories[i].list[j].name;
                  if(this.$data.currentMerchantItem.categories[i].list[j].public_name != null && this.$data.currentMerchantItem.categories[i].list[j].public_name.length > 0) {
                    menuName = this.$data.currentMerchantItem.categories[i].list[j].public_name;
                  }
                  redeemables.push(menuName);
                }
              }
            }
          }
        }

        if(redeemables.length > 0) {
          this.$data.redeemables = redeemables;
          this.$data.redeemableManualSeen = true;
        }
      },
      getMenuImage: function(menuId) {
        // console.log("getMenuImage " + menuId);
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          // console.log("getMenuImage no current Merchant Item");
          return '';
        }
        if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
          // console.log("getMenuImage current Merchant Item no categories");
          return '';
        }


        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              // console.log("Return no menu image "+ this.$data.currentMerchantItem.categories[i].list[j].image_url);
              if(this.$data.currentMerchantItem.categories[i].list[j].imgs != undefined && this.$data.currentMerchantItem.categories[i].list[j].imgs.length > 0) {
                return this.$data.currentMerchantItem.categories[i].list[j].imgs[0];
              } else {
                return "";
              }

            }
          }
        }
        // console.log("Return no menu image for " + menuId);
        return '';
      },
      getMenuDescription: function(menuId) {
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return '';
        }
        if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
          return '';
        }


        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              if(this.$data.currentMerchantItem.categories[i].list[j].description != null) {
                return this.$data.currentMerchantItem.categories[i].list[j].description;
              } else {
                return '';
              }

            }
          }
        }
        return '';
      },
      getMenuIngredients: function(menuId) {
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return '';
        }
        if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
          return '';
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              if(this.$data.currentMerchantItem.categories[i].list[j].ingredients != null) {
                return this.$data.currentMerchantItem.categories[i].list[j].ingredients;
              } else {
                return '';
              }

            }
          }
        }
        return '';
      },
      showHistoryList: function() {
        if(this.$data.orderHistory.length > 0) {
          this.$data.showHistory = true;
          let path = this.$data.basePath + "?history";
          this.$router.push(path);
        }
      },
      clickedOnYes: function() {
        this.$data.popup.show = false;
        if(this.$data.popup.yesCb != null) {
          this.$data.popup.yesCb();
        }
        this.intialisePopup();

      },
      clickedOnNo: function() {
        this.$data.popup.show = false;
        if(this.$data.popup.noCb != null) {
          this.$data.popup.noCb();
        }
        this.intialisePopup();

      },
      closeRedeemManual: function() {
        this.$data.redeemables = false;
      },
      clickedOnBackground: function() {
        if(this.$data.popup.bgCb != null) {
          this.$data.popup.bgCb();
        }
        this.intialisePopup();
      },
      doNothingOnClick: function() {

      },
      closeAdvert: function() {
        this.$data.advertImage = false;
      },
      intialisePopup: function() {
        this.$data.popup.show = false;
        this.$data.popup.title = '';
        this.$data.popup.message = '';
        this.$data.popup.yesBtnTitle = '';
        this.$data.popup.noBtnTitle = '';
        this.$data.popup.yesCb = null;
        this.$data.popup.noCb = null;
        this.$data.popup.bgCb = null;
      },
      showPopup: function(title, message, yesBtnTitle = "", noBtnTitle = "", yesCb = null, noCb = null, bgCb = null) {
        this.$data.popup.title = title;
        this.$data.popup.message = message;
        this.$data.popup.yesBtnTitle = yesBtnTitle;
        this.$data.popup.noBtnTitle = noBtnTitle;
        this.$data.popup.yesCb = yesCb;
        this.$data.popup.noCb = noCb;
        this.$data.popup.show = true;
        this.$data.popup.bgCb = bgCb
        // console.log(this.$data.popup);
      },


      /**
       * Open / Select Restaurant
       * Select -> Get menus -> Sort menus
       * @param merchant
       */
      merchantSelected: function(merchant) {
        merchant.categories = [];
        merchant.options = [];
        merchant.priceSchedules = [];
        merchant.discounts = [];
        merchant.priceOptions = [];

        this.$data.images = [];
        if(merchant.imageUrl != null && merchant.imageUrl.length > 0) {
          this.$data.images = merchant.imageUrl.split(',');
        }
        this.$data.minOrder = 0;
        this.$data.delayTime = 0;
        if(merchant.delayTime != undefined) {
          this.$data.delayTime = merchant.delayTime;
        }
        this.$data.currentMerchantItem = JSON.parse(JSON.stringify(merchant));
        // console.log(this.$data.currentMerchantItem);
        EventBus.$emit("setTitle", this.$data.currentMerchantItem.title);

        this.setPageMeta();
        submitLog(this.$data.currentMerchantItem.merchantId, 'OrderPage', this.$data.type)
          .then(function(data){

          })
          .catch(function(err){

          })
        // console.log(this.$data.currentMerchantItem);
        // console.log("Merchant Selected " + this.$data.type + " SC rate " + this.$data.currentMerchantItem.serviceChargeRate);
        this.setOpeningTime();
        this.getMenus(this.$data.currentMerchantItem.merchantId);
        // console.log("Call Get menus")




        // console.log("Now check advert");
        // console.log(this.$data.currentMerchantItem);
        if(this.$data.currentMerchantItem.adverts !== undefined && this.$data.currentMerchantItem.adverts.length > 0) {
          // console.log("Adverts");
          // console.log(this.$data.currentMerchantItem.adverts);

          let adverts = JSON.parse(this.$data.currentMerchantItem.adverts);
          for(let i = 0 ; i < adverts.length ; i++) {
            // console.log(adverts[i]);
            let advert = adverts[i];
            let today = millisToDate();
            if(today >= advert.from && today <= advert.to && this.$data.type === advert.type) {
              // console.log("Today is inside");
              this.$data.advertImage = advert.imageUrl;
              break;
            } else {
              // console.log("Today is not inside");
            }

          }
        }



      },
      newPreSession: function() {
        this.$data.newPreOrder = {
          id:0,
          merchantName:this.$data.currentMerchantItem.title,
          name:'',
          phoneNumber:'',
          email:'',
          subscriptionId: this.$data.currentMerchantItem.merchantId,
          state:-1000,
        }
      },
      createNewPreSession: function() {
        if(this.$data.newPreOrder == false) {
          return;
        }

        if(this.$data.newPreOrder.name === '') {
          this.showPopup("", "Name or group name required to create new session");
          return;
        }
        if(this.$data.newPreOrder.phoneNumber === '') {
          this.showPopup("", "Phone Number required to create new session");
          return;
        }
        let self = this;
        createNewPreOrder(this.$data.newPreOrder)
          .then(function(data){
            if(data.success) {
              self.forwardToSession(data.item.id);
            } else {
              self.showPopup("Sorry", data.message);
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
      },
      forwardToSession: function(id) {
        let basePath = this.$route.path.split('/')[1];
        if(this.$route.query.hasOwnProperty("id")) {
          Router.push('/' +basePath + '/' + this.$route.query.id + '/' + this.$data.type  + '/preorder/' + id);
        } else if(this.$route.params.hasOwnProperty("id")) {
          Router.push('/' +basePath + '/' + this.$route.params.id + '/' + this.$data.type  + '/preorder/' + id);
        }
      },
      getPreOrder: function(id) {
        let self = this;
        getPreOrder(id)
          .then(function(data) {

            if(data.success == true) {
              // if(data.item.list != undefined && data.item.list != null && data.item.list.length > 0) {
              //   for(let i = 0 ; i < data.item.list.length ; i++) {
              //     if(data.item.list[i].options != null && data.item.list[i].options.length > 0) {
              //       data.item.list[i].options = JSON.parse(data.item.list[i].options);
              //     }
              //     if(data.item.list[i].optionSelection != null && data.item.list[i].optionSelection.length > 0) {
              //       data.item.list[i].optionSelection = JSON.parse(data.item.list[i].optionSelection);
              //     }
              //   }
              // }
              self.$data.order = data.item;
              self.reorderItem();
              self.subscribeTableOrder();
              // console.log(self.$data.order);
            } else {
              self.$data.order = false;
              self.showPopup("", data.message, "", "", null, null,
                function(){
                  window.location.href = "https://showmethemenu.net";
                })

            }
          })
          .catch(function(err){

          })
      },
      checkForTableOrder: function() {

        /**
         * Check Location
         */
        let self = this;
        self.setLoadingView(false);
        self.onDistanceCheckedForTableOrder();

        return;

        if(navigator.geolocation) {
          // console.log("getting location");
          self.setLoadingView(true, "Checking Location..");
          navigator.geolocation.getCurrentPosition(position => {
            self.setLoadingView(false);
            // console.log("position");
            // console.log(position);
            self.$data.position.lat = position.coords.latitude;
            self.$data.position.lng = position.coords.longitude;
            // self.getRestaurantList();
            let from = position.coords.latitude + ',' + position.coords.longitude;
            let to = self.$data.currentMerchantItem.lat + ',' + self.$data.currentMerchantItem.lng;
            getDistance(from, to)
              .then(function(data){
                // console.log(data);
                if(data.success == true) {
                  let r = JSON.parse(data.message);
                  if(r.routes != undefined && r.routes.length > 0) {
                    // console.log("1")
                    if (r.routes[0].legs != undefined && r.routes[0].legs.length > 0) {
                      // console.log("2")
                      let leg = r.routes[0].legs[0];

                      if (leg.distance != undefined && leg.distance.value != undefined) {
                        // console.log("3")
                        self.$data.distance = Number(leg.distance.value);
                        // console.log("Distance is " + leg.distance.value + "metres");
                        if(self.$data.distance < 20) {
                          self.onDistanceCheckedForTableOrder();
                        } else {
                          self.onTooFar();
                        }
                      }
                    }
                  }
                }
              })
              .catch(function(err) {
                // console.log(err);
              })
          }, error => {
            self.setLoadingView(false);
            // console.log("Could not get position");
            // console.log(error);
            self.onTooFar();
            // self.getRestaurantList();
          });
        } else {
          self.setLoadingView(false);
          // console.log("No geolocation");
          self.onTooFar();
          // this.getRestaurantList();
        }
      },

      onTooFar: function() {

        // console.log("Merchant " + this.$data.currentMerchantItem);
        // console.log(this.$data.currentMerchantItem);
        if(this.$data.currentMerchantItem.merchantId == 1
          || this.$data.currentMerchantItem.merchantId == 10
          || this.$data.currentMerchantItem.merchantId == 15
          || this.$data.currentMerchantItem.merchantId == 19
          || this.$data.currentMerchantItem.merchantId == 26) {
          this.onDistanceCheckedForTableOrder();
          return;
        }
        let title = "Table Order";
        if(this.$data.distance > 0) {
          title += " " + this.$data.distance + " metres away";
        }
        // this.onDistanceCheckedForTableOrder();
        // return;
        this.showPopup(title, "Sorry, you do not seem to be in restaurant. If location is not enabled, please allow location to ensure that you are in restaurant when scan QR code again",
          "", "",
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          },
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          },
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          });

      },
      onDistanceCheckedForTableOrder: function() {
        this.getPendingTable();
      },

      checkIfOpen: function() {
        if(this.$data.isOpen == false) {
          return false;
        }

        if(this.$data.slots.length == 0) {
          return false;
        }

        let now = new Date().getTime();
        for(let i = 0 ; i < this.$data.slots.length ; i++) {
          if(now > this.$data.slots[i].from && now < this.$data.slots[i].to) {
            return true;
          }
        }
        return false;
      },
      checkDeliveryOpen: function() {

      },
      setOpeningTime: function() {
        this.$data.slots = [];
        this.$data.isOpen = false;
        if(this.$data.preorder == true) {
          this.$data.isOpen = true;

          let today = new Date();
          today.setHours(10, 0, 0, 0);
          let fromTime = today.getTime();
          today.setHours(23, 0, 0, 0);
          let toTime = today.getTime();
          let slot = {
            from: fromTime,
            to: toTime,
            fromString: '10:00',
            toString: '23:00',
          };
          this.$data.slots.push(slot);

        } else if(this.$data.currentMerchantItem.openingTime != null && this.$data.currentMerchantItem.openingTime.length > 3) {

          this.$data.openingTime = JSON.parse(this.$data.currentMerchantItem.openingTime);
          if(this.$data.type === 'delivery' && this.$data.currentMerchantItem.deliveryTime != null && this.$data.currentMerchantItem.deliveryTime.length > 0) {
            this.$data.deliveryTime = JSON.parse(this.$data.currentMerchantItem.deliveryTime);
          }


          if(this.$data.openingTime != null && this.$data.openingTime.length > 0) {
            let today = new Date();
            let dayOfWeek = today.getDay();
            let time = this.$data.openingTime[dayOfWeek];

            if(time != undefined && time != null) {
              // console.log(time);
              this.$data.isShopOpen = time.open;


              if (this.$data.isShopOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();

                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();

                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.shopSlots.push(slot);
                }
              }
            }
          }

          if(this.$data.type === 'delivery' && this.$data.deliveryTime != false && this.$data.deliveryTime.length > 0) {
            let today = new Date();
            let dayOfWeek = today.getDay();

            let time = this.$data.deliveryTime[dayOfWeek];

            if(time != undefined && time != null) {
              this.$data.isOpen = time.open;


              if (this.$data.isOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();

                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();

                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.slots.push(slot);
                }
              }
            }



            if(this.$data.slots.length == 0 || this.$data.isOpen == false ) {
              this.showPopup("", "No delivery available today.");
            } else if(this.$data.isOpen && this.$data.slots.length > 0) {
              let message = "Delivery available at";
              let available = false;
              let now = new Date().getTime();
              for(let i = 0 ; i < this.$data.slots.length ; i++) {
                message += '<br>' + this.$data.slots[i].fromString +' ~ ' + this.$data.slots[i].toString;
                if(now >= this.$data.slots[i].from && now < this.$data.slots[i].to) {
                  available = true;
                }
              }
              if(this.$data.isShopOpen) {
                message += '<br><br>Restaurants open at';
                for(let i = 0 ; i < this.$data.shopSlots.length ; i++) {
                  message += '<br>' + this.$data.shopSlots[i].fromString +' ~ ' + this.$data.shopSlots[i].toString;
                }
                message += '<br>Would you like to move to takeaway menus?';
              }
              message += '<br>';
              let self = this;
              if(available == false) {
                this.showPopup("", message, "Move to Takeaway", "Stay", function () {
                  self.$data.popup.show = false;
                  let basePath = self.$route.path.split('/')[1];

                  // basePath = 'order';
                  if (self.$route.query.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.query.id + '/'+newtype);
                    window.location.href = '/' + basePath + '/' + self.$route.query.id + '/takeaway';
                    // Router.push('/' +basePath + '/' + self.$route.query.id + '/' + newtype);
                    self.$route.query.type = newtype;
                  } else if (self.$route.params.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.params.id + '/'+newtype);
                    window.location.href = '/' + basePath + '/' + self.$route.params.id + '/takeaway';
                    // Router.push('/' +basePath + '/' + self.$route.params.id + '/' + newtype);
                    self.$route.params.type = newtype;
                  }
                });
              }
            }
          } else if(this.$data.openingTime != null && this.$data.openingTime.length > 0) {
            let today = new Date();
            let dayOfWeek = today.getDay();
            let time = this.$data.openingTime[dayOfWeek];

            if(time != undefined && time != null) {
              // console.log(time);
              this.$data.isOpen = time.open;


              if (this.$data.isOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();

                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();

                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.slots.push(slot);
                }
              }
            }


          }


        }
        if(this.$data.currentMerchantItem.deliveryZone != null && this.$data.currentMerchantItem.deliveryZone.length > 3) {
          let deliverySetting = JSON.parse(this.$data.currentMerchantItem.deliveryZone);
          if(deliverySetting.acceptCash != undefined) {
            this.$data.acceptCash = deliverySetting.acceptCash;
          }
          if(deliverySetting.cashLimit != undefined) {
            this.$data.cashLimit = deliverySetting.cashLimit;
          }
          if(deliverySetting.acceptCard != undefined) {
            this.$data.acceptCard = deliverySetting.acceptCard;
          }

          if(deliverySetting.acceptStripe != undefined) {
            this.$data.acceptStripe = deliverySetting.acceptStripe;
          }

          if(deliverySetting.cashBtnTitle != undefined) {
            this.$data.cashBtnTitle = deliverySetting.cashBtnTitle;
          }
          if(deliverySetting.cardBtnTitle != undefined) {
            this.$data.cardBtnTitle = deliverySetting.cardBtnTitle;
          }
          if(deliverySetting.stripeBtnTitle != undefined) {
            this.$data.stripeBtnTitle = deliverySetting.stripeBtnTitle;
          }
          // if(deliverySetting.enableDelivery != undefined) {
          //   this.$data.enableDelivery = deliverySetting.enableDelivery;
          // }
          if(deliverySetting.enableTakeaway != undefined) {
            this.$data.enableTakeaway = deliverySetting.enableTakeaway;
          }
          if(deliverySetting.taDelay != undefined) {
            this.$data.taDelay = Number(deliverySetting.taDelay);
          }
          if(deliverySetting.deliveryDelay != undefined) {
            this.$data.deliveryDelay = Number(deliverySetting.deliveryDelay);
          }
          if(deliverySetting.deliveryTimePerMile != undefined) {
            this.$data.deliveryTimePerMile = Number(deliverySetting.deliveryTimePerMile);
          }
          if(deliverySetting.interval != undefined) {
            this.$data.interval = Number(deliverySetting.interval);
          }
          this.applyOrderTimingDefaults();
          if(deliverySetting.lastOrder != undefined) {
            this.$data.lastOrder = Number(deliverySetting.lastOrder);
          }
          if(deliverySetting.lastDeliveryOrder != undefined) {
            this.$data.lastDeliveryOrder = Number(deliverySetting.lastDeliveryOrder);
          }
          if(deliverySetting.additionalDelay != undefined) {
            this.$data.additionalDelay = Number(deliverySetting.additionalDelay);
          }
          if(deliverySetting.additionalDelayPrice != undefined) {
            this.$data.additionalDelayPrice = Number(deliverySetting.additionalDelayPrice)*100;
          }
          if(deliverySetting.deliveryPriceByDistance != undefined) {
            this.$data.deliveryPriceByDistance = deliverySetting.deliveryPriceByDistance;
          }
          if(deliverySetting.distanceChargeList != undefined) {
            this.$data.distanceChargeList = deliverySetting.distanceChargeList;
          }
          this.applyDeliveryChargeLimitSettings(deliverySetting);
        }
        this.$data.enableDelivery = this.$data.currentMerchantItem.webDelivery == 1?true:false;
        if(this.$data.type == 'takeaway' && this.$data.currentMerchantItem.promotion != undefined && this.$data.currentMerchantItem.promotion.length > 3) {
          this.$data.promotions = JSON.parse(this.$data.currentMerchantItem.promotion);

          if(this.$data.promotions.length > 0) {
            let today = millisToDate();
            for(let i = 0 ; i < this.$data.promotions.length ; i++) {
              // console.log("tday " + today + " ");
              // console.log(this.$data.promotions[i]);
              if(today >= this.$data.promotions[i].from && today <= this.$data.promotions[i].to) {
                this.$data.promotion = this.$data.promotions[i];

                break;
              }
            }
          }
        }
        if(this.$data.currentMerchantItem.points != undefined && this.$data.currentMerchantItem.points.length > 3) {
          this.$data.points = JSON.parse(this.$data.currentMerchantItem.points);
        }
        this.refreshDojoPaymentReady();
        this.refreshTeyaPaymentReady();


      },
      getPromotionPrice: function(price) {
        if(this.$data.promotion == false) {
          return "";
        }
        let today = millisToDate();
        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            return price*(100-amount)/100;
          } else {
            //Amount
            return price;
          }
        }
      },
      promotionEligable: function(item) {

        let price = item.price;
        if(this.$data.type == 'takeaway') {
          if(item.price_ta > 0) {
            price = item.price_ta;
          }
        } else if(this.$data.type == 'delivery') {
          if(item.price_delivery > 0) {
            price = item.price_delivery;
          } else if(item.price_ta > 0) {
            price = item.price_ta;
          }
        }
        if(this.$data.promotion == false || item.excludeFromPromotion == 1) {
          return "£" + Number(price).toFixed(2);
        }

        let newPrice = 0;
        let today = millisToDate();

        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            newPrice = (price*(100-amount)/100);
          }

        }

        if(newPrice < price) {
          return this.$data.promotion.title + ' ' + this.$data.promotion.amount + '%<br>' + '<del>£' + Number(price).toFixed(2) + '</del>&nbsp;&nbsp;' + "£" + Number(newPrice).toFixed(2);
        } else {
          return "£" + Number(price).toFixed(2);
        }
      },
      // promotionEligable: function(item) {
      //   let price = item.price;
      //   if(this.$data.type == 'takeaway' || this.$data.type == 'delivery') {
      //     if(item.price_ta > 0) {
      //       price = item.price_ta;
      //     }
      //   }
      //   if(this.$data.promotion == false) {
      //     return "£" + (price).toFixed(2);
      //   }
      //
      //   let newPrice = 0;
      //   let today = millisToDate();
      //   if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
      //     let amount = this.$data.promotion.amount;
      //     if(this.$data.promotion.type == 0) {
      //       //Percent
      //       newPrice = (price*(100-amount)/100);
      //     }
      //
      //   }
      //
      //   if(newPrice < price) {
      //     return this.$data.promotion.title + ' ' + this.$data.promotion.amount + '%<br>' + '<del>£' + Number(price).toFixed(2) + '</del>&nbsp;&nbsp;' + "£" + Number(newPrice).toFixed(2);
      //   } else {
      //     return "£" + Number(price).toFixed(2);
      //   }
      // },
      getPrice: function(price) {
        // let price = 0;
        let today = millisToDate();
        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            price = (price*(100-amount)/100);
          }

        }
        return price;
      },
      checkDelivery: function() {
        if(this.$data.currentMerchantItem.deliveryZone != null && this.$data.currentMerchantItem.deliveryZone.length > 3) {
          this.$data.currentMerchantItem.delivery = JSON.parse(this.$data.currentMerchantItem.deliveryZone);

          if(this.$data.currentMerchantItem.delivery.useDistanceLimit != undefined && this.$data.currentMerchantItem.delivery.useDistanceLimit == true) {
            this.$data.showPostCodeInput = true;
          }
          if(this.$data.currentMerchantItem.delivery.minOrder != undefined) {
            this.$data.minOrder = this.$data.currentMerchantItem.delivery.minOrder*100;
          }
        }
      },
      searchAddress:function() {
        this.$data.showPostCodeInput = true;
        this.$data.postCodeSearchWord = '';
        this.$data.addressCandidates = [];
        this.$data.selectedCandidate = '';
      },
      getAddressCandidates: function() {
        var postcode = (this.$data.postCodeSearchWord || '').replace(/[^A-Za-z0-9 ]/g, '').trim();
        if(postcode == '') {
          this.showPopup("", "Please Enter Post code");
          return;
        }
        this.$data.postCodeSearchWord = postcode.toUpperCase();
        let self = this;
        self.$data.addressCandidates = [];
        self.$data.selectedCandidate = '';
        getDeliveryAddresses(this.$data.postCodeSearchWord)
          .then(function(data) {
            if (data != null && data.success == true && data.list != undefined && data.list.length > 0) {
              self.$data.addressCandidates = data.list;
              return;
            }
            var message = "Sorry no address found";
            if (data != null && data.message != undefined && data.message.length > 0) {
              message = data.message;
            }
            self.showPopup("", message);
          })
          .catch(function() {
            self.showPopup("", "Sorry no address found");
          });
      },
      selectCandidate: function(address) {
        this.$data.selectedCandidate = address;
        this.processAddress();
      },
      processAddress: function() {
        if(this.$data.selectedCandidate == null || this.$data.selectedCandidate == '' || this.$data.selectedCandidate.length == 0) {
          this.showPopup("", "No Address Selected");
          return;
        }
        this.$data.address = this.$data.selectedCandidate;
        this.closeDeliveryAddressPicker();
        this.onPostCodeEntered();
      },
      closeDeliveryAddressPicker: function() {
        if(this.$data.order != false) {
          this.$data.order.address = this.$data.address;
        }
        this.$data.showPostCodeInput = false;
        this.$data.postCodeSearchWord = '';
        this.$data.addressCandidates = [];
      },
      acceptEnteredDeliveryAddress: function() {
        this.closeDeliveryAddressPicker();
        this.$data.distanceOk = true;
        if(this.$data.order != false) {
          this.calculatePrice();
        }
      },
      getDeliveryDistanceOrigin: function() {
        if (this.$data.currentMerchantItem && this.$data.currentMerchantItem.address && String(this.$data.currentMerchantItem.address).trim().length > 0) {
          return String(this.$data.currentMerchantItem.address).trim();
        }
        var delivery = this.$data.currentMerchantItem && this.$data.currentMerchantItem.delivery;
        if (delivery && delivery.postCodeFrom != undefined && String(delivery.postCodeFrom).trim().length > 0) {
          return String(delivery.postCodeFrom).trim();
        }
        return '';
      },
      /**
       * Parses the delivery charge type / delivery limit mode fields from the
       * merchant deliveryZone JSON, migrating legacy zones that only carry
       * fixedDeliveryCharge / usePostCode. Amounts are stored in pence.
       */
      applyDeliveryChargeLimitSettings: function(deliverySetting) {
        let toPence = function(value) {
          let n = parseFloat(value);
          return (isFinite(n) && n > 0) ? Math.round(n * 100) : 0;
        };
        let legacyFixed = toPence(deliverySetting.fixedDeliveryCharge);
        let type = Number(deliverySetting.deliveryChargeType);
        if (!isFinite(type) || type < 0 || type > 3) {
          // Legacy zone: fixed charge > 0 behaved like an always-on fixed charge.
          type = legacyFixed > 0 ? 1 : 0;
        }
        this.$data.deliveryChargeType = Math.floor(type);
        if (deliverySetting.deliveryChargeAmount !== undefined) {
          this.$data.deliveryChargeAmount = toPence(deliverySetting.deliveryChargeAmount);
        } else {
          this.$data.deliveryChargeAmount = legacyFixed;
        }
        this.$data.freeDeliveryOver = toPence(deliverySetting.freeDeliveryOver);
        this.$data.deliveryBaseCharge = toPence(deliverySetting.deliveryBaseCharge);
        this.$data.deliveryChargePerMilePrice = toPence(deliverySetting.deliveryChargePerMile);
        if (deliverySetting.limitType === 'distance' || deliverySetting.limitType === 'postcode') {
          this.$data.limitType = deliverySetting.limitType;
        } else {
          this.$data.limitType = (deliverySetting.usePostCode === true || deliverySetting.usePostCode === 'true') ? 'postcode' : 'distance';
        }
      },
      logDeliveryDistance: function() {
      },
      isDeliveryDistanceLimitEnabled: function(value) {
        return value === true || value === 1 || value === '1' || value === 'true';
      },
      getDeliveryMaxDistanceMetres: function(delivery) {
        var raw = delivery ? delivery.distanceLimit : null;
        var miles = parseFloat(raw);
        if (raw == null || raw === '' || !isFinite(miles) || miles < 0) {
          return NaN;
        }
        return miles * 1600;
      },
      extractFullPostcode: function(address) {
        if (!address || typeof address !== 'string') {
          return '';
        }
        var matches = String(address).toUpperCase().match(/[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}/g);
        if (matches && matches.length > 0) {
          return matches[matches.length - 1].replace(/\s+/g, '');
        }
        return '';
      },
      extractOutwardPostcode: function(address) {
        var full = this.extractFullPostcode(address);
        if (!full) {
          return '';
        }
        var match = full.match(/^([A-Z]{1,2}[0-9][A-Z0-9]?)[0-9][A-Z]{2}$/);
        return match ? match[1] : '';
      },
      normalizeDeliveryAddress: function(address) {
        if (!address || typeof address !== 'string') {
          return '';
        }
        return address.toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
      },
      isSameDeliveryLocation: function(from, to) {
        var fromNorm = this.normalizeDeliveryAddress(from);
        var toNorm = this.normalizeDeliveryAddress(to);
        if (!fromNorm || !toNorm) {
          return false;
        }
        if (fromNorm === toNorm) {
          return true;
        }
        var fromPc = this.extractFullPostcode(from);
        var toPc = this.extractFullPostcode(to);
        return !!(fromPc && fromPc === toPc);
      },
      readGoogleDistanceMetres: function(data) {
        try {
          if (data == null || data.success != true || !data.message) {
            this.logDeliveryDistance('google-parse', {
              success: data && data.success,
              hasMessage: !!(data && data.message),
              metres: null
            });
            return null;
          }
          var parsed = JSON.parse(data.message);
          var routes = parsed && parsed.routes;
          var legs = routes && routes.length > 0 ? routes[0].legs : null;
          var distance = legs && legs.length > 0 ? legs[0].distance : null;
          var metres = null;
          if (distance != null && distance.value !== undefined && distance.value !== null) {
            metres = Number(distance.value);
            if (!isFinite(metres) || metres < 0) {
              metres = null;
            }
          }
          this.logDeliveryDistance('google-parse', {
            success: data.success,
            googleStatus: parsed && parsed.status,
            errorMessage: parsed && parsed.error_message,
            routeCount: routes ? routes.length : 0,
            distanceText: distance ? distance.text : null,
            distanceValue: distance ? distance.value : null,
            metres: metres
          });
          return metres;
        } catch (err) {
          this.logDeliveryDistance('google-parse-error', { error: err && err.message });
          return null;
        }
      },
      applyDeliveryDistanceResult: function(metres, useDistanceLimit, maxDistance, postCodeAllowed) {
        var limitMiles = isFinite(maxDistance) ? (maxDistance / 1600) : null;
        var resultMiles = metres !== null && isFinite(metres) ? (metres / 1600) : null;
        var overLimit = useDistanceLimit && postCodeAllowed == false && metres !== null && isFinite(metres) && isFinite(maxDistance) && maxDistance > 0 && metres > maxDistance;
        this.logDeliveryDistance('apply-result', {
          metres: metres,
          miles: resultMiles,
          maxDistanceMetres: maxDistance,
          limitMiles: limitMiles,
          useDistanceLimit: useDistanceLimit,
          postCodeAllowed: postCodeAllowed,
          overLimit: overLimit
        });
        if (metres !== null && isFinite(metres)) {
          this.$data.distance = metres;
          if (overLimit) {
            var message = "";
            if(this.$data.currentMerchantItem.delivery.beyondLimitMessage != undefined && this.$data.currentMerchantItem.delivery.beyondLimitMessage.length > 0) {
              message = this.$data.currentMerchantItem.delivery.beyondLimitMessage;
            }
            this.logDeliveryDistance('reject-too-far', {
              metres: metres,
              miles: resultMiles,
              limitMiles: limitMiles,
              message: message
            });
            this.rejectDeliveryDistance(message);
            return;
          }
          this.logDeliveryDistance('accept', { metres: metres, miles: resultMiles, reason: maxDistance > 0 ? 'within-limit' : 'limit-not-applied' });
          this.acceptEnteredDeliveryAddress();
          return;
        }
        if (this.isSameDeliveryLocation(this.getDeliveryDistanceOrigin(), this.$data.address)) {
          this.logDeliveryDistance('accept', { metres: 0, miles: 0, reason: 'same-location-fallback' });
          this.$data.distance = 0;
          this.acceptEnteredDeliveryAddress();
          return;
        }
        if(useDistanceLimit && postCodeAllowed == false) {
          this.logDeliveryDistance('reject-no-distance', { metres: metres, maxDistanceMetres: maxDistance });
          this.rejectDeliveryDistance("Sorry, we could not check delivery distance. Please try again.");
          return;
        }
        this.logDeliveryDistance('accept', { metres: metres, reason: 'distance-limit-disabled' });
        this.acceptEnteredDeliveryAddress();
      },
      rejectDeliveryDistance: function(message) {
        this.$data.distanceOk = false;
        var self = this;
        this.showPopup("", message || "Sorry, this address is too far for delivery", "", "", null, null, function(){
          let basePath = self.$route.path.split('/')[1];
          if(self.$route.query.hasOwnProperty("id")) {
            window.location.href = '/' +basePath + '/' + self.$route.query.id + '/takeaway';
            self.$route.query.type = 'takeaway';
          } else if(self.$route.params.hasOwnProperty("id")) {
            window.location.href = '/' +basePath + '/' + self.$route.params.id + '/takeaway';
            self.$route.params.type = 'takeaway';
          }
        });
      },
      onPostCodeEntered: function() {
        if(this.$data.address == false) {
          return;
        }
        if(this.$data.currentMerchantItem.delivery == undefined || this.$data.currentMerchantItem.delivery == null) {
          this.$data.currentMerchantItem.delivery = {};
        }
        let to = this.$data.address;
        if(this.$data.order != false) {
          this.$data.order.address = to;
        }
        this.$data.distanceOk = false;

        let postCodeAllowed = false;
        if(this.$data.limitType === 'postcode') {
          if(this.$data.currentMerchantItem.delivery.postCodeList != undefined
            && this.$data.currentMerchantItem.delivery.postCodeList !== ''
            && this.$data.currentMerchantItem.delivery.postCodeList.length > 0) {
            let firstCode = this.extractOutwardPostcode(to);
            if(firstCode.length > 0) {
              for(let p = 0 ; p < this.$data.currentMerchantItem.delivery.postCodeList.length ; p++) {
                if(this.$data.currentMerchantItem.delivery.postCodeList[p].postCode === firstCode) {
                  postCodeAllowed = true;
                  break;
                }
              }
            }
          }
          if(postCodeAllowed == false) {
            let pcMessage = "";
            if(this.$data.currentMerchantItem.delivery.beyondLimitMessage != undefined && this.$data.currentMerchantItem.delivery.beyondLimitMessage.length > 0) {
              pcMessage = this.$data.currentMerchantItem.delivery.beyondLimitMessage;
            }
            this.logDeliveryDistance('reject-postcode', { outwardPostcode: this.extractOutwardPostcode(to) });
            this.rejectDeliveryDistance(pcMessage || "Sorry, we do not deliver to your post code");
            return;
          }
        }

        let from = this.getDeliveryDistanceOrigin();
        let delivery = this.$data.currentMerchantItem.delivery;
        let maxDistance = this.getDeliveryMaxDistanceMetres(delivery);
        // Distance limit only applies in 'distance' mode; 0 (or blank) means no limit.
        let useDistanceLimit = this.$data.limitType === 'distance' && isFinite(maxDistance) && maxDistance > 0;
        this.logDeliveryDistance('start', {
          from: from,
          to: to,
          merchantAddress: this.$data.currentMerchantItem.address,
          postCodeFrom: delivery.postCodeFrom,
          useDistanceLimitRaw: delivery.useDistanceLimit,
          useDistanceLimit: useDistanceLimit,
          distanceLimitRaw: delivery.distanceLimit,
          maxDistanceMetres: maxDistance,
          limitMiles: isFinite(maxDistance) ? maxDistance / 1600 : null,
          postCodeAllowed: postCodeAllowed,
          outwardPostcode: this.extractOutwardPostcode(to),
          fullPostcode: this.extractFullPostcode(to),
          sameLocation: this.isSameDeliveryLocation(from, to)
        });

        if(!from) {
          this.logDeliveryDistance('no-origin', { useDistanceLimit: useDistanceLimit, postCodeAllowed: postCodeAllowed });
          if(useDistanceLimit && postCodeAllowed == false) {
            this.rejectDeliveryDistance("Delivery distance cannot be checked. Please call the restaurant.");
            return;
          }
          this.acceptEnteredDeliveryAddress();
          return;
        }

        if (this.isSameDeliveryLocation(from, to)) {
          this.logDeliveryDistance('accept', { metres: 0, miles: 0, reason: 'same-location' });
          this.$data.distance = 0;
          this.acceptEnteredDeliveryAddress();
          return;
        }

        let self = this;
        this.setLoadingView(true, "Getting Distance...");
        getDistance(from, to)
          .then(function(data){
            self.setLoadingView(false);
            self.logDeliveryDistance('google-http', {
              success: data && data.success,
              messageLength: data && data.message ? String(data.message).length : 0
            });
            self.applyDeliveryDistanceResult(self.readGoogleDistanceMetres(data), useDistanceLimit, maxDistance, postCodeAllowed);
          })
          .catch(function(err) {
            self.setLoadingView(false);
            self.logDeliveryDistance('google-http-error', { error: err && (err.message || String(err)) });
            self.applyDeliveryDistanceResult(null, useDistanceLimit, maxDistance, postCodeAllowed);
          });
      },
      onTypeClicked: function(newType) {
        if(this.$data.type === newType) {
          return;
        }
        if(newType === 'takeaway' && this.$data.enableTakeaway == false) {
          this.showPopup("", "Takeaway is not available");
          return;
        }
        if(newType == 'delivery' && this.$data.enableDelivery == false) {
          this.showPopup("", "Delivery is not available");
          return;
        }
        // if(this.$data.enableTakeaway == false || this.$data.enableDelivery == false) {
        //   return;
        // }
        let message = 'Do you want to change to ';
        let newtype = '';
        if(this.$data.type == 'takeaway') {
          message += 'Delivery order';
          newtype = 'delivery';
        } else if(this.$data.type === 'delivery') {
          message += 'Takeaway order';
          newtype = 'takeaway';
        } else {
          return;
        }

        message += '?';
        let self = this;
        this.showPopup("",message, "Change", "No",
          function(){
            self.$data.popup.show = false;
            let basePath = self.$route.path.split('/')[1];

            // basePath = 'order';
            if(self.$route.query.hasOwnProperty("id")) {
              // console.log("move to " + '/' +basePath + '/' + self.$route.query.id + '/'+newtype);
              window.location.href = '/' +basePath + '/' + self.$route.query.id + '/' + newtype;
              // Router.push('/' +basePath + '/' + self.$route.query.id + '/' + newtype);
              self.$route.query.type = newtype;
            } else if(self.$route.params.hasOwnProperty("id")) {
              // console.log("move to " + '/' +basePath + '/' + self.$route.params.id + '/'+newtype);
              window.location.href = '/' +basePath + '/' + self.$route.params.id + '/' + newtype;
              // Router.push('/' +basePath + '/' + self.$route.params.id + '/' + newtype);
              self.$route.params.type = newtype;
            }
            // self.$data.type = newtype;
            // self.updatePage();                  // if(self.$route.params.hasOwnProperty('id')) {
            //   // console.log("Params " + this.$route.params.id);
            //   Router.push('/restaurant?id='+self.$route.params.id + '&type=' + newtype);
            //   console.log("Push to " + '/restaurant?id='+self.$route.params.id + '&type=' + newtype);
            // } else if(self.$route.query.hasOwnProperty('id')) {
            //   // console.log("Query " + this.$route.query.id);
            //   Router.push('/restaurant?id='+self.$route.query.id + '&type=' + newtype);
            //   console.log("Push to " + '/restaurant?id='+self.$route.query.id + '&type=' + newtype);
            // }

          },
          function(){
            self.$data.popup.show = false;
          })
      },
      getMenus: function(merchantId) {
        let self = this;
        // let check1 = new Date().getTime();
        EventBus.$emit("showLoading", true, "Getting menu list");
        let type = 'pos';

        // console.log("getMenus");
        getMerchantMenus(merchantId, type)
          .then(function(data) {
            EventBus.$emit("showLoading", false);
            // let check2 = new Date().getTime();
            // console.log("Get menu time " + (check2-check1));
            if(data.success == true) {
              if(data.list != undefined) {
                // console.log("Menus");
                // console.log(data.list)
                // let menusString = '{"list":' + data.list + '}';
                // menus = JSON.parse(menusString);
                // console.log()
                self.populateMenus(data.list);
              }
            } else {
              console.error('Request failed');
            }
          })
          .catch(function(err) {
            EventBus.$emit("showLoading", false);
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
      },
      populateMenus: function(list) {
        this.$data.currentMerchantItem.categories = [];
        this.$data.currentMerchantItem.options = [];
        this.$data.currentMerchantItem.priceSchedules = [];
        this.$data.currentMerchantItem.discounts = [];
        this.$data.currentMerchantItem.priceOptions = [];


        let recommendedCat = {
          id:-2,
          name: 'Recommended',
          list:[],
        }
        let popularCat = {
          id:-1,
          name: 'Popular',
          list:[],
        }
        for(let i = 0 ; i < list.length ; i++) {
          // console.log(list[i].name + " Type " + list[i].type + " id " + list[i].id);

          if(list[i].content != null && list[i].content.length > 0) {
            // console.log(list[i].content);
            list[i].content = JSON.parse(list[i].content);
          }
          // console.log("Passed");
          if(list[i].type === 'public_category' || list[i].type === 'category') {
            // console.log("Category " + list[i].name);
            if(list[i].isPublic == 0 && this.$data.type === 'table') {
              continue;
            }
            if((this.$data.type === 'takeaway' || this.$data.type === 'delivery') && list[i].takeaway == 0) {
              continue;
            }
            if(list[i].list != null && list[i].list.length > 0) {
              for (let j = 0; j < list[i].list.length; j++) {

                if(list[i].list[j].icons != null && list[i].list[j].icons.length > 0) {
                  list[i].list[j].icons = JSON.parse(list[i].list[j].icons);
                } else {
                  list[i].list[j].icons = [];
                }
                list[i].list[j].alcohol = false;
                if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                  list[i].list[j].content = JSON.parse(list[i].list[j].content);
                  if(list[i].list[j].content.alcohol != undefined) {
                    list[i].list[j].alcohol = list[i].list[j].content.alcohol;
                  }
                }
                list[i].list[j].imgs = [];
                if(list[i].list[j].image_url != null && list[i].list[j].image_url.length > 0) {
                  list[i].list[j].imgs = list[i].list[j].image_url.split(',');

                }
                list[i].list[j].tableAvailable = true;
                list[i].list[j].tableMessage = "";
              }
              for (let j = list[i].list.length-1; j >= 0 ; j--) {

                if((list[i].list[j].type != 'product' && list[i].list[j].type != 'set_product') || list[i].list[j].isPublic == 0) {
                  list[i].list.splice(j,1);

                  continue;
                }
                if((this.$data.type === 'takeaway' || this.$data.type === 'delivery') && list[i].list[j].takeaway == 0) {
                  list[i].list.splice(j,1);
                  continue;
                }

                if(list[i].list[j].tableTags.length > 0) {
                  let tags = list[i].list[j].tableTags.split(',');

                  if(this.$data.tableTags.length == 0) {
                    // list[i].list.splice(j,1);
                    list[i].list[j].tableAvailable = false;
                    list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                    continue;
                  }

                  let tableMatching = false;

                  for(let ti = 0 ; ti < tags.length ; ti++) {
                    for(let tti = 0 ; tti < this.$data.tableTags.length ; tti++) {
                      if(tags[ti] === this.$data.tableTags[tti]) {
                        tableMatching = true;
                        break;
                      }
                    }
                    if(tableMatching == true) {
                      break;
                    }
                  }

                  if(tableMatching == false) {
                    // list[i].list.splice(j,1);
                    list[i].list[j].tableAvailable = false;
                    list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                    continue;
                  }
                }

              }
            }
            this.$data.currentMerchantItem.categories.push(list[i]);
          } else if(list[i].type === 'option') {
            if((this.$data.type == 'takeaway' || this.$data.type == 'delivery') && list[i].takeaway == 0) {
              continue;
            }
            this.$data.currentMerchantItem.options.push(list[i]);
            if(list[i].list != null && list[i].list.length > 0) {
              for (let j = 0; j < list[i].list.length; j++) {
                if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                  list[i].list[j].content = JSON.parse(list[i].list[j].content);
                }
              }
            }
            // console.log("option " + list[i].name);
            // console.log(list[i]);

          } else if(list[i].type === 'price_schedule') {
            this.$data.currentMerchantItem.priceSchedules.push(list[i]);
          } else if(list[i].type === 'discount') {
            this.$data.currentMerchantItem.discounts.push(list[i]);
          } else if(list[i].type === 'price_option') {
            this.$data.currentMerchantItem.priceOptions.push(list[i]);
          }
        }
        // console.log("Price Schedules ");
        // console.log(this.$data.currentMerchantItem.priceSchedules);
        // Check Price Schedue
        if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
          for(let i = this.$data.currentMerchantItem.categories.length - 1 ; i >= 0  ; i--) {
            // console.log("Check cat PS " + this.$data.currentMerchantItem.categories[i].name);
            let content = this.$data.currentMerchantItem.categories[i].content;
            // console.log(content);
            if(content == null || content.price_schedule === undefined || content.price_schedule.length == 0) {
              // console.log("No content price schedule");
              continue;
            }

            let priceSchedule = content.price_schedule;
            let toShow = false;
            for(let s = 0 ; s < priceSchedule.length ; s++) {
              if(this.isMeetPriceSchedule(priceSchedule[s].id) == true) {
                toShow = true;
              }
            }

            if(toShow == false) {
              this.$data.currentMerchantItem.categories.splice(i, 1);
            }
          }
        }
        // console.log("Price Schedules Check finsished");
        if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
          for (let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
            // console.log("CATEGORY " + this.$data.currentMerchantItem.categories[i].name);
            if(this.$data.currentMerchantItem.categories[i].list != undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {

                let content = this.$data.currentMerchantItem.categories[i].list[j].content;
                // console.log(content);
                if(content == null || content.price_schedule === undefined || content.price_schedule.length == 0) {

                  continue;
                }
                // console.log("Check price schedule " + this.$data.currentMerchantItem.categories[i].list[j].name);
                let priceSchedule = content.price_schedule;
                for(let s = 0 ; s < priceSchedule.length ; s++) {
                  // console.log("price schedule check " + priceSchedule[s].id)
                  if(this.isMeetPriceSchedule(priceSchedule[s].id) == true) {
                    // console.log("Matching price scedule");
                    // console.log(priceSchedule[s]);
                    this.$data.currentMerchantItem.categories[i].list[j].price = priceSchedule[s].price;
                    break;
                  }
                }
              }
            }

          }
        }

        if(this.$data.currentMerchantItem.categories.length > 0) {
          for (let i = 0; i < this.$data.currentMerchantItem.categories.length; i++) {
            // console.log("CATEGORY " + this.$data.currentMerchantItem.categories[i].name);
            if (this.$data.currentMerchantItem.categories[i].list != undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for (let j = 0; j < this.$data.currentMerchantItem.categories[i].list.length; j++) {
                if (this.$data.currentMerchantItem.categories[i].list[j].recommended == 1) {
                  recommendedCat.list.push(JSON.parse(JSON.stringify(this.$data.currentMerchantItem.categories[i].list[j])));
                }

                if (this.$data.currentMerchantItem.categories[i].list[j].popular == 1) {
                  popularCat.list.push(JSON.parse(JSON.stringify(this.$data.currentMerchantItem.categories[i].list[j])));
                }
              }
            }
          }
        }

        if(popularCat.list.length > 0) {
          this.$data.currentMerchantItem.categories.unshift(popularCat)
        }
        if(recommendedCat.list.length > 0) {
          this.$data.currentMerchantItem.categories.unshift(recommendedCat)
        }


        // console.log("Categories");
        // console.log(this.$data.currentMerchantItem.categories);

        // console.log(this.$data.currentMerchantItem);

        this.getUserPoint();
      },

      isMeetPriceSchedule: function(pid) {
        // console.log("isMeetPriceSchedule " + pid);
        if(this.$data.currentMerchantItem.priceSchedules.length == 0) {
          // console.log("no price schedules");
          return true;
        }
        let today = new Date();
        let day = today.getDay();
        day = day-1;
        if(day < 0) {
          day = 6;
        }
        let tableType = 'dinein';
        if(this.$data.type == 'takeaway') {
          tableType = 'takeaway';
        } else if(this.$data.type == 'delivery') {
          tableType = 'delivery';
        }

        let HM = millisToHM(today.getTime());
        for(let i = 0 ; i < this.$data.currentMerchantItem.priceSchedules.length ; i++) {
          if(this.$data.currentMerchantItem.priceSchedules[i].id == pid) {
            // console.log("now check " + this.$data.currentMerchantItem.priceSchedules[i].name);
            if(this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == undefined  || this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == false) {
              // console.log(this.$data.currentMerchantItem.priceSchedules[i].content.type);
              // console.log("Canot find tableType " + tableType);
              return false;
            }
            let days = this.$data.currentMerchantItem.priceSchedules[i].content.dayOfWeek;
            // console.log("days " + day);
            // console.log(days);
            if(days[day].apply == true) {
              // console.log("compare time " + HM + "  range " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);
              if(HM >= this.$data.currentMerchantItem.priceSchedules[i].content.from && HM < this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                // console.log("day time is in range " + HM + " " + days[day].from + " - " + days[day].to);
                return true;
              }

            }
            // console.log("nothing matches");
            return false;

          }
        }
        // console.log("no price schedules");
        return true;
      },
      selectMenuAnim: function(item) {
        if(item.soldOut == 1) {
          return;
        }
        if(item.tableAvailable == false) {
          return;
        }
        setTimeout(this.selectMenu, this.$data.animDuration, item);
      },
      selectMenu: function(item) {


        let path = this.$data.basePath + '?item='+item.id;
        if(this.$data.currentPath !== path) {
          this.$router.push(path);
        }

        // console.log("select Menu");
        // console.log(item);
        let orderItem = {
          id:0,
          parentId:0,
          recordType:0,
          itemType: 0,
          menuName: item.name,
          publicMenuName: item.name,
          menuId: item.id,
          amount:1,
          price: Math.round(item.price*100),
          originalPrice: Math.round(item.price*100),
          totalPrice: Math.round(item.price*100),
          taxRate: Math.round(item.tax_rate*100),
          taxAmount:0,
          discountAmount:0,
          discountTitle:'',
          optionSelection:[],
          orderedAmount:0,
          orderedTime:0,
          customerIndex:0,
          subscriptionId: this.$data.currentMerchantItem.merchantId,
          description: JSON.parse(JSON.stringify(item.content)),
          notifyKitchen: item.notify_kitchen==1?true:false,
          notifyBar: item.notify_bar==1?true:false,
          asMain: false,
          optionPrice:0,
          options:[],
          status:0,
          state:0,
          memo:'',
          pointsUsed:0,
          pricePoints:item.pricePoints,
          imgs:item.imgs,
          tags:this.$data.UUID,
          excludeFromPromotion: item.excludeFromPromotion,
          alcohol: false,
          icons: JSON.parse(JSON.stringify(item.icons)),
          youtube: item.youtube,
        }
        if(item.alcohol != undefined) {
          orderItem.alcohol = item.alcohol;
        }
        if(item.public_name != undefined && item.public_name != null && item.public_name.length > 0) {
          orderItem.publicMenuName = item.public_name;
        }
        if(this.$data.type === 'takeaway') {
          if(item.price_ta > 0) {
            orderItem.price = Number(item.price_ta * 100);
            orderItem.originalPrice = Number(item.price * 100);
          }
          orderItem.taxRate = Number(item.tax_rate_ta * 100);
        } else if(this.$data.type === 'delivery') {
          if(item.price_delivery > 0) {
            orderItem.price = Number(item.price_delivery * 100);
            orderItem.originalPrice = Number(item.price * 100);
          } else if(item.price_ta > 0) {
            orderItem.price = Number(item.price_ta * 100);
            orderItem.originalPrice = Number(item.price * 100);
          }
        }
        if(orderItem.excludeFromPromotion == 0) {
          orderItem.price = this.getPrice(orderItem.price);
        }
        // console.log("Price " + orderItem.price);
        orderItem.totalPrice = orderItem.price;
        // if(this.$data.order == false || this.$data.order.list.length == 0) {
        //   orderItem.id = 1;
        // } else {
        //   orderItem.id = this.$data.order.list.length;
        // }
        if(item.content != null) {
          // let content = JSON.parse(item.content);

          if(item.content.section_list != undefined) {
            if(this.shouldShowSetSelectionView(orderItem) == true) {
              return;
            }
          }
          // console.log(item.content);
          if(item.content.options != undefined) {
            //Check if option needs to be selected
            if(this.shouldShowOptionSelectionView(orderItem) == true) {
              //Show Option View
              // console.log("should show option view");
              return;
            }
          }
        }

        // if(item.public_name != null && item.public_name.length > 0) {
        //   orderItem.menuName = item.public_name;
        // }

        this.$data.optionSelectItem = orderItem;
        // console.log("select item " + this.$data.optionSelectItem.pricePoints);

        // console.log("select item");
        // console.log(this.$data.optionSelectItem);
//        return true;
        // this.addOrderItem(orderItem);


      },
      changeItemAmount: function(index, diff) {
        this.$data.order.list[index].amount += diff;
        this.$data.order.list[index].totalPrice = this.$data.order.list[index].price*this.$data.order.list[index].amount;
        this.calculatePrice();
      },
      /**
       * Delivery charge in pence based on the merchant's delivery charge type.
       * Type 0: no charge. Type 1: fixed charge always. Type 2: fixed charge
       * when the items subtotal is below freeDeliveryOver. Type 3: base charge
       * + ceiling(distance in miles) * charge per mile.
       */
      getDeliveryCharge: function() {
        let type = Number(this.$data.deliveryChargeType);
        if(type === 1) {
          return this.$data.deliveryChargeAmount;
        }
        if(type === 2) {
          let itemsTotal = (this.$data.order != false && this.$data.order.totalPrice != undefined) ? Number(this.$data.order.totalPrice) : 0;
          if(itemsTotal >= this.$data.freeDeliveryOver) {
            return 0;
          }
          return this.$data.deliveryChargeAmount;
        }
        if(type === 3) {
          let metres = Number(this.$data.distance);
          let miles = (isFinite(metres) && metres > 0) ? Math.ceil(metres / 1600) : 0;
          return this.$data.deliveryBaseCharge + miles * this.$data.deliveryChargePerMilePrice;
        }
        return 0;
      },
      myTotal: function() {
        if(this.$data.order == false) {
          return '0.00';
        }

        if(this.$data.order.list.length == 0) {
          return '0.00';
        }

        let myTotal = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].tags != null && this.$data.order.list[i].tags === this.$data.UUID) {
            myTotal += this.$data.order.list[i].totalPrice;
          }
        }
        return Number(myTotal/100).toFixed(2);
      },

      addOrderItemTable: function(item) {
        // console.log("item add now to table");
        if(this.$data.order == false) {
          this.$data.order = {
            list:[],
            id:0,
            recordType:0,
            merchantName:this.$data.currentMerchantItem.title,
            menuName:this.$data.tableItem.name,
            tableId:this.$data.tableItem.id,
            price: 0,
            originalPrice: 0,
            orderedAmount: 0,
            totalPrice: 0,
            taxAmount:0,
            taxRate:0,
            serviceChargeRate:0,
            serviceChargeAmount:0,
            totalDue:0,
            optionPrice:0,
            subscriptionId: this.$data.currentMerchantItem.merchantId,
            state:0,
            phoneNumber:'',
            name:'',
            email:'',
            pickupTime:'',
            pickupTimeMilli:0,
            memo:'',
            useSms: this.$data.currentMerchantItem.useSms==1?true:false,
            useEmail: this.$data.currentMerchantItem.useEmail==1?true:false,
            postCode: '',
            address:'',
            points:0,
            pointsUsed:0,
            paymentMethod:'',
            title:'',
            deliveryCharge:0,
            riderFee:0,
            totalFee:0,
            deliveryOption:'Leave at door',
            deliveryInstruction:'',
          }


          if(this.$data.type === 'delivery' && this.$data.address != false) {
            this.$data.order.address = this.$data.address;
            // console.log("address is set " + this.$data.order.address);
          }
          let title = {
            merchantAddress:this.$data.currentMerchantItem.address,
            contact: this.$data.currentMerchantItem.contact,
          }
          this.$data.order.title = JSON.stringify(title);
          // if(this.$data.tableItem.table_type === 'Take Away') {
          //   this.$data.order.recordType = 1;
          //   this.$data.order.menuName += ' (Web)';
          // } else if(this.$data.tableItem.table_type === 'Delivery') {
          //   this.$data.order.recordType = 2;
          //   this.$data.order.menuName += ' (Web)';
          // } else if(this.$data.type == 'table') {
          //   this.$data.order.serviceChargeRate = this.$data.currentMerchantItem.serviceChargeRate*100;
          // }
          // if(item.pointsUsed > 0) {
          //   this.$data.order.pointsUsed = item.pointsUsed;
          // }
          // console.log("Used Points " + this.$data.order.pointsUsed);
          // if(this.$data.type == 'delivery') {
          //   this.$data.order.deliveryCharge = this.getDeliveryCharge();
          // }

        }
        // if(this.checkIfSame(item) == false) {
        this.$data.order.list.push(item);
        // }
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));

        if(orderItem.memo.length > 0) {
          if(orderItem.memo.includes("'")) {
            orderItem.memo = orderItem.memo.replace("'", "");
          }
          if(orderItem.memo.includes('"')) {
            orderItem.memo = orderItem.memo.replace('"', "");
          }
          // orderItem.memo = orderItem.memo.replace(/[^a-zA-Z ]/g, "");
        }
        for(let i = 0 ; i < orderItem.list.length ; i++) {
          if(orderItem.list[i].id > 0) {
            continue;
          }
          orderItem.list[i].optionSelection = JSON.stringify(this.buildOptionSelection(orderItem.list[i]));
          // console.log(orderItem.list[i])
          orderItem.list[i].options = JSON.stringify(orderItem.list[i].options);
          if(orderItem.list[i].memo.length > 0) {
            if(orderItem.list[i].memo.includes("'")) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace("'", "");
            }
            if(orderItem.list[i].memo.includes('"')) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace('"', "");
            }
            // orderItem.list[i].memo = orderItem.list[i].memo.replace(/[^a-zA-Z ]/g, "");
          }
          // console.log(orderItem.list[i])
        }
        let self = this;

        // console.log(orderItem);

        // addItemsToTable(orderItem)
        //   .then(function(data) {
        //     if(data.success == true) {
        //       // console.log("Added item");
        //       // console.log(data.item);
        //       self.$data.order = data.item;
        //       self.reorderItem();
        //       self.notifyTableFriends();
        //       self.subscribeTableOrder();
        //
        //     }
        //   })
        //   .catch(function(err) {
        //
        //     // console.log("Error adding item to table " + err);
        //     if(err.response != undefined) {
        //       // console.log(err.response);
        //     }
        //   })

      },
      notifyTableFriends: function() {
        // console.log("notify friends");
        if(this.$data.order == false || this.$data.order.id == 0) {
          // console.log("notify friends do nothing");
          return;
        }

        let channel = 'posPublic/' + this.$data.order.id.toString();

        let obj = {
          id:this.$data.order.id,
          totalDue: this.$data.order.totalDue,
        }
        this.sendMessage(channel, JSON.stringify(obj));
      },
      addOrderItem: function(item) {
        if(this.$data.order == false) {
          this.$data.order = {
            list:[],
            id:0,
            recordType:0,
            merchantName:this.$data.currentMerchantItem.title,
            menuName:this.$data.tableItem.name,
            tableId:this.$data.tableItem.id,
            price: 0,
            originalPrice: 0,
            orderedAmount: 0,
            totalPrice: 0,
            taxAmount:0,
            taxRate:0,
            serviceChargeRate:0,
            serviceChargeAmount:0,
            totalDue:0,
            optionPrice:0,
            subscriptionId: this.$data.currentMerchantItem.merchantId,
            state:0,
            phoneNumber:'',
            name:'',
            email:'',
            pickupTime:'',
            pickupTimeMilli:0,
            memo:'',
            useSms: this.$data.currentMerchantItem.useSms==1?true:false,
            useEmail: this.$data.currentMerchantItem.useEmail==1?true:false,
            postCode: '',
            address:'',
            points:0,
            pointsUsed:0,
            paymentMethod:'',
            title:'',
            deliveryCharge:0,
            boriumDelivery: false,
            deliveryOption: 'Leave at door',


          }
          if(this.$data.type === 'delivery' && this.$data.address != false) {
            this.$data.order.address = this.$data.address;
            // console.log("address is set " + this.$data.order.address);
          }

          let title = {
            merchantAddress:this.$data.currentMerchantItem.address,
            contact: this.$data.currentMerchantItem.contact,
          }
          this.$data.order.title = JSON.stringify(title);
          if(this.$data.tableItem.table_type === 'Take Away') {
            this.$data.order.recordType = 1;
            this.$data.order.menuName += ' (Web)';
          } else if(this.$data.tableItem.table_type === 'Delivery') {
            this.$data.order.recordType = 2;
            this.$data.order.menuName += ' (Web)';
          }
          if(item.pointsUsed > 0) {
            this.$data.order.pointsUsed = item.pointsUsed;
          }
          // console.log("Used Points " + this.$data.order.pointsUsed);
          if(this.$data.type == 'delivery') {
            this.$data.order.deliveryCharge = this.getDeliveryCharge();
          }

        }



        if(this.checkIfSame(item) == false) {
          this.$data.order.list.push(item);
        }
        this.calculatePrice();

      },
      checkIfSame: function(item) {
        // console.log("checkIfSame");
        if(this.$data.order == false) {
          // console.log("no order")
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          // console.log("no order list");
          return false;
        }
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {

          if(this.$data.order.list[i].menu_id == item.menu_id) {


            // console.log("item");
            // console.log(item);
            // console.log("from list");
            // console.log(this.$data.order.list[i]);
            if(this.$data.order.list[i].ordered_amount > 0) {
              // console.log("ordered amount")
              continue;
            }
            if(this.$data.order.list[i].menuName !== item.menuName) {
              // console.log("menu name")
              continue;
            }
            if(this.$data.order.list[i].publicMenuName !== item.publicMenuName) {
              // console.log("public_menu_name")
              continue;
            }
            if(this.$data.order.list[i].price != item.price) {
              // console.log("price")
              continue;
            }
            if(this.$data.order.list[i].optionPrice != item.optionPrice) {
              // console.log("optionPrice")
              continue;
            }

            if(this.$data.order.list[i].options.length != item.options.length ) {
              // console.log("options")
              continue;
            }

            if(JSON.stringify(this.$data.order.list[i].options) !== JSON.stringify(item.options)) {
              continue;
            }

            /**
             * the same menu
             */
            this.itemAmountChanged(item.amount, i);
            return true;

          }


        }
        return false;
      },

      getDistanceString: function(distance) {
        return (distance/1600).toFixed(1) + 'miles';
      },
      calculatePrice: function() {
        let totalPrice = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          totalPrice += Number(this.$data.order.list[i].totalPrice);
        }
        // console.log(totalPrice);

        this.$data.order.totalPrice = totalPrice;
        // console.log("service charge rate " + this.$data.order.serviceChargeRate);
        if(this.$data.order.serviceChargeRate > 0) {
          this.$data.order.serviceChargeAmount = Number(totalPrice*this.$data.order.serviceChargeRate/100).toFixed(2);
        } else {
          this.$data.order.serviceChargeAmount = 0;
        }
        // console.log(this.$data.order.totalPrice);
        this.$data.order.discountAmount = 0;
        // if(this.$data.promotion != false) {
        //   let today = millisToDate();
        //
        //   if (today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
        //     let amount = this.$data.promotion.amount;
        //     if (this.$data.promotion.type == 0) {
        //       //Percent
        //       this.$data.order.discountAmount = totalPrice * amount / 100;
        //       console.log("DC " + this.$data.order.discountAmount);
        //       this.$data.order.discountTitle = this.$data.promotion.title;
        //     } else {
        //       //Amount
        //
        //     }
        //   }
        // }

        // console.log("calculate total due " + Number(this.$data.order.totalPrice) + " " + Number(this.$data.order.serviceChargeAmount) + " " + Number(this.$data.order.discountAmount) + " " + Number(this.$data.order.deliveryCharge));

        if(this.$data.type == 'delivery') {
          if(this.$data.currentMerchantItem.boriumDelivery == 1) {

            //let additionalDeliveryCharge = 0;

            if (Number(this.$data.order.totalPrice) / 5 < 600) {
              this.$data.order.deliveryCharge = 600 - (Number(this.$data.order.totalPrice) / 5);
              this.$data.order.riderFee = 400;
              this.$data.order.totalFee = 600;
            } else {
              this.$data.order.deliveryCharge = 0;
              this.$data.order.riderFee = 400;
              this.$data.order.totalFee = Number(this.$data.order.totalPrice) / 5;
            }

            if(this.$data.distance > 3200) {
              let additionalDistance = this.$data.distance - 3200;
              let additionalDeliveryCharge = (Math.floor(additionalDistance/1600) + 1)*200;
              this.$data.order.riderFee += additionalDeliveryCharge;
              this.$data.order.deliveryCharge += additionalDeliveryCharge;
              this.$data.order.totalFee += additionalDeliveryCharge;
            }
            this.$data.order.distance = this.$data.distance;
          } else {
            this.$data.order.deliveryCharge = this.getDeliveryCharge();
          }
        }
        this.$data.order.totalDue = Number(this.$data.order.totalPrice) + Number(this.$data.order.serviceChargeAmount) - Number(this.$data.order.discountAmount) + Number(this.$data.order.deliveryCharge) ;

        // console.log("total Due " + this.$data.order.totalDue);

        if(this.$data.points != false && this.$data.points.enabled && this.$data.order.pointsUsed == 0) {
          if(this.$data.points.pointAwardPrice > 0 && this.$data.order.totalDue > this.$data.points.pointAwardPrice) {
            let points = this.$data.order.totalDue%this.$data.points.pointAwardPrice;

            if(this.$data.points.pointsPerTransaction == 1) {
              if(points > 1) {
                points = 1;
              }
            }
            this.$data.order.points = points;
          } else {
            this.$data.order.points = 0;
          }

        } else {
          this.$data.order.points = 0;
        }

      },
      isOptionToShow: function(id) {
        // console.log("isOptionToShow " + id);
        // console.log(this.$data.currentMerchantItem.options)
        if(this.$data.currentMerchantItem.options == null || this.$data.currentMerchantItem.options == undefined || this.$data.currentMerchantItem.options.length == 0) {
          return false;
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
          if(this.$data.currentMerchantItem.options[i].id == id){
            // console.log(this.$data.currentMerchantItem.options[i]);
            if(this.$data.currentMerchantItem.options[i].content.required != undefined && this.$data.currentMerchantItem.options[i].content.required == true) {
              return true;
            }
            if(this.$data.currentMerchantItem.options[i].content.always_show != undefined && this.$data.currentMerchantItem.options[i].content.always_show == true) {
              return true;
            }
          }
        }
        return false;
      },
      shouldShowSetSelectionView: function(item) {
        // console.log("shouldShowSetSelectionView")
        if(item.description == null || item.description == undefined) {
          return false;
        }

        // let list = JSON.parse(content);

        if(item.description.section_list == undefined) {
          return false;
        }

        item.sections = [];

        let optionAvailable = false;
        for(let i = 0 ; i < item.description.section_list.length ; i++) {
          let sectionAvailable = false;
          let pids = item.description.section_list[i].list;
          let section = JSON.parse(JSON.stringify(item.description.section_list[i]));
          section.products = [];
          for(let j = 0 ; j < pids.length ; j++) {
            let productItem = this.getSetSelectionItem(pids[j]);
            if(productItem != null) {
              productItem.selected = false;
              section.products.push(productItem);
              sectionAvailable = true;
            }
          }

          if(sectionAvailable) {
            item.sections.push(section);
          }
        }
        if(item.sections.length > 0) {
          this.$data.setSelectItem = item;
          // console.log("options");
          // console.log(this.$data.optionSelectItem);
          // this.registerBackHandler();
          return true;
        }
        return false;
        // for(let i = 0 ; i < item.description.section.length ; i++) {
      },
      shouldShowOptionSelectionView: function(item) {
        // console.log("shouldShowOptionSelectionView")
        if(item.description == null || item.description == undefined) {
          return false;
        }

        // let list = JSON.parse(content);

        if(item.description.options == undefined) {
          return false;
        }

        // console.log(item.description.options);

        item.options = [];
        let optionAvailable = false;
        for(let i = 0 ; i < item.description.options.length ; i++) {
          let optionId = item.description.options[i].id;
          let optionItem = this.getOptionSelectionItem(optionId, item.excludeFromPromotion);
          if(optionItem != null) {

            // console.log(optionItem.list);
            item.options.push(optionItem)
            optionAvailable = true;
          }
        }
        if(optionAvailable == true) {
          this.$data.optionSelectItem = item;
          // console.log("options");
          // console.log(this.$data.optionSelectItem);
          // this.registerBackHandler();
          return true;
        }
        return false;

      },
      getSetSelectionItem: function(pid) {
        if(this.currentMerchantItem.categories == 0) {
          return null;
        }

        for(let i = 0 ; i < this.currentMerchantItem.categories.length ; i++) {
          if(this.currentMerchantItem.categories[i].list == undefined || this.currentMerchantItem.categories[i].list == null || this.currentMerchantItem.categories[i].list.length == 0) {
            continue;
          }

          for(let j = 0 ; j < this.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.currentMerchantItem.categories[i].list[j].id == pid) {
              let item = JSON.parse(JSON.stringify(this.currentMerchantItem.categories[i].list[j]));

              item.options = [];
              if(item.content != undefined && item.content != null) {
                if(item.content.options != undefined) {

                  for(let k = 0 ; k < item.content.options.length ; k++) {
                    let optionItem = this.getOptionSelectionItem(item.content.options[k].id);
                    if(optionItem != null) {
                      item.options.push(optionItem);
                    }
                  }
                }
              }
              return item;
            }
          }
        }
        return null;
      },
      getOptionSelectionItem: function(optionId, excludeFromPromotion = 0) {
        if(this.$data.currentMerchantItem.options == null || this.$data.currentMerchantItem.options == undefined || this.$data.currentMerchantItem.options.length == 0) {
          return null;
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
          if (this.$data.currentMerchantItem.options[i].id == optionId) {
            let item = JSON.parse(JSON.stringify(this.$data.currentMerchantItem.options[i].content));
            // item.children = [];
            // if(this.$data.currentMerchantItem.options[i].list != null && this.$data.currentMerchantItem.options[i].list.length > 0) {
            //
            //   for(let j = 0 ; j < this.$data.currentMerchantItem.options[i].list.length ; j++) {
            //     let childOption = JSON.parse(JSON.stringify(this.$data.currentMerchantItem.options[i].list[j].content));
            //
            //     childOption.name= this.$data.currentMerchantItem.options[i].list[j].name;
            //     childOption.public_name= this.$data.currentMerchantItem.options[i].list[j].public_name;
            //     // childOption.list = [];
            //     if(item.list != undefined && item.list.length > 0) {
            //       for(let k = 0 ; k < childOption.list.length ; k++) {
            //         childOption.list[k].selected = false;
            //         childOption.list[k].originalPrice = childOption.list[k].field_price;
            //         childOption.list[k].field_price = this.getPrice(childOption.list[k].field_price);
            //       }
            //     }
            //     item.children.push(childOption);
            //     // console.log("Child");
            //     // console.log(childOption);
            //   }
            //
            // }
            item.id = this.$data.currentMerchantItem.options[i].id;
            item.name = this.$data.currentMerchantItem.options[i].name;
            item.public_name = this.$data.currentMerchantItem.options[i].public_name;
            item.min_order = this.$data.currentMerchantItem.options[i].min_order;
            if(item.list != undefined && item.list.length > 0) {
              for(let j = 0 ; j < item.list.length ; j++) {
                item.list[j].selected = false;
                if(this.$data.type == 'delivery' && item.list[j].field_price_delivery != undefined && Number(item.list[j].field_price_delivery) > 0) {
                  item.list[j].field_price = item.list[j].field_price_delivery;
                }
                item.list[j].originalPrice = item.list[j].field_price;
                if(excludeFromPromotion == 0) {
                  item.list[j].field_price = this.getPrice(item.list[j].field_price);
                }
                if(item.list[j].soldOut == undefined) {
                  item.list[j].soldOut = false;
                }
                // console.log(item.list[j]);
              }
            }
            // console.log("Option");
            // console.log(item);
            return item;
          }
        }
        return null;
      },
      checkIfOptionToShow: function(optionId, item) {
        // console.log(this.$data.currentMerchantItem.options);
        for(let i = 0 ; i < item.description.options.length ; i++) {
          if(item.description.options[i].id == optionId) {
            return true;
          }
        }
        return false;
      },
      isOptionSelected: function(item) {
        // console.log("isOptionSelected " + optionName);
        // console.log(optionItem);
        if(item.list != null) {
          for(let i = 0 ; i < item.list.length ; i++) {
            if(item.list[i].selected == true) {
              return true;
            }
          }
        }
        return false;
      },
      selectOption: function(item, optionItem, option) {
        let optionSelect =  {
          option: option.name,
          field: optionItem.field_name,
          price: optionItem.field_price,

        };
        item.optionSelection.push(optionSelect);
        // console.log("Select Option")
        // console.log(item.option_selection)
      },
      toggleSetSection: function(sectionIndex, productIndex) {
        for(let i = 0 ; i < this.$data.setSelectItem.sections[sectionIndex].products.length ; i++) {
          this.$data.setSelectItem.sections[sectionIndex].products[i].selected = i==productIndex;
        }
        // this.$data.setSelectItem.sections[sectionIndex].products[productIndex].selected = !this.$data.setSelectItem.sections[sectionIndex].products[productIndex].selected;
      },
      toggleSetSectionProductOption: function(sectionIndex, pi, optionIndex, oi) {
        if (this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].choice == 0) {
          this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[oi].selected = !this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[oi].selected;
        }
        // Only single Choice
        else {
          if (this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].required != undefined && this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].required == true) {
            for (let i = 0; i < this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list.length; i++) {
              this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = oi == i ? true : false;
            }
          } else {
            for (let i = 0; i < this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list.length; i++) {
              if (oi == i) {
                this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = !this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected;
              } else {
                this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = false;
              }
            }
          }
        }
        this.setSelectionItemPrice();
      },
      toggleOption: function(index, oi, ci = -1, viewId = null) {

        // Multiple choice is possible

        // console.log("toggleOption " + index + " " + oi + " " + ci);
        if(ci > -1) {
          // console.log("toggleOption");
          // console.log(this.optionSelectItem.options[index]);
          if (this.optionSelectItem.options[index].children[oi].choice == 0) {
            this.optionSelectItem.options[index].children[oi].list[ci].selected = !this.optionSelectItem.options[index].children[oi].list[ci].selected;
            // console.log(this.optionSelectItem.options[index].children[oi].list[ci].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[ci].selected);
          }
          // Only single Choice
          else {

            if(this.optionSelectItem.options[index].children[oi].required != undefined && this.optionSelectItem.options[index].children[oi].required == true) {
              for (let i = 0; i < this.optionSelectItem.options[index].children[oi].list.length; i++) {
                this.optionSelectItem.options[index].children[oi].list[i].selected = ci == i ? true : false;
                // console.log(this.optionSelectItem.options[index].children[oi].list[i].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[i].selected);
              }
            } else {

              for (let i = 0; i < this.optionSelectItem.options[index].children[oi].list.length; i++) {
                if(ci == i) {
                  this.optionSelectItem.options[index].children[oi].list[i].selected = !this.optionSelectItem.options[index].children[oi].list[i].selected;
                } else {
                  this.optionSelectItem.options[index].children[oi].list[i].selected = false;
                }
                // console.log(this.optionSelectItem.options[index].children[oi].list[i].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[i].selected);
              }
            }
          }
          // console.log(this.optionSelectItem.options[index].children[oi]);
        } else {
          if (this.optionSelectItem.options[index].choice == 0) {
            this.optionSelectItem.options[index].list[oi].selected = !this.optionSelectItem.options[index].list[oi].selected;

            // console.log("Option item");
            // console.log(this.optionSelectItem.options[index]);
            // check if it exceedes
            if(this.optionSelectItem.options[index].min_order > 1) {
              let selectedCount = 0;
              for(let k = 0 ; k < this.optionSelectItem.options[index].list.length ; k++) {
                if(this.optionSelectItem.options[index].list[k].selected == true) {
                  selectedCount += 1;
                  if(selectedCount > this.optionSelectItem.options[index].min_order) {
                    this.optionSelectItem.options[index].list[k].selected = false;
                    selectedCount -= 1;
                  }
                }
              }

            }
          }
          // Only single Choice
          else {
            if (this.optionSelectItem.options[index].required != undefined && this.optionSelectItem.options[index].required == true) {
              for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
                this.optionSelectItem.options[index].list[i].selected = oi == i ? true : false;
              }
            } else {
              for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
                if (oi == i) {
                  this.optionSelectItem.options[index].list[i].selected = !this.optionSelectItem.options[index].list[i].selected;
                } else {
                  this.optionSelectItem.options[index].list[i].selected = false;
                }
              }
            }
          }
          let childrenToRemove = [];
          let childrenToAdd = [];
          this.optionSelectItem.options[index].children = [];
          for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
            // console.log(this.optionSelectItem.options[index].list[i].field_name + " check " + this.optionSelectItem.options[index].list[i].selected);
            if(this.optionSelectItem.options[index].list[i].selected == true && this.optionSelectItem.options[index].list[i].field_child != undefined && this.optionSelectItem.options[index].list[i].field_child > 0) {
              // console.log("to add " + this.optionSelectItem.options[index].list[i].field_child );
              childrenToAdd.push(this.optionSelectItem.options[index].list[i].field_child);
            } else if(this.optionSelectItem.options[index].list[i].selected == false && this.optionSelectItem.options[index].list[i].field_child != undefined && this.optionSelectItem.options[index].list[i].field_child > 0) {
              // console.log("to remove " + this.optionSelectItem.options[index].list[i].field_child );
              childrenToRemove.push(this.optionSelectItem.options[index].list[i].field_child);
            }
          }
          // console.log(this.optionSelectItem.options);
          for(let i = 0 ; i < childrenToRemove.length ; i++) {
            let toRemove = childrenToRemove[i];
            if(this.optionSelectItem.options.length > 0) {
              for (let j = this.optionSelectItem.options.length - 1; j >= 0; j--) {
                // console.log("To Remove check " + this.optionSelectItem.options[j].id + " " + toRemove);
                if (this.optionSelectItem.options[j].id == toRemove) {
                  this.optionSelectItem.options.splice(j, 1);
                  // break;
                }
              }
            }
          }

          for(let i = 0 ; i < childrenToAdd.length ; i++) {
            let toAdd = childrenToAdd[i];
            let found = false;
            for(let j = 0 ; j < this.optionSelectItem.options.length ; j++) {
              if(this.optionSelectItem.options[j].id == toAdd ) {
                // this.optionSelectItem.children.splice(j, 1);
                found = true;
                break;
              }
            }
            if(found == false) {
              let itemToAdd = this.getOptionSelectionItem(toAdd, this.optionSelectItem.excludeFromPromotion);
              this.optionSelectItem.options.push(itemToAdd);
            }
          }


          // if(this.optionSelectItem.options[index].children != undefined && this.optionSelectItem.options[index].children.length > 0) {
          //   let selected = false;
          //   for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
          //     if(this.optionSelectItem.options[index].list.selected == true) {
          //       selected = true;
          //       break;
          //     }
          //   }
          //   if(selected == false) {
          //     for(let i = 0 ; i < this.optionSelectItem.options[index].children.length ; i++) {
          //       if(this.optionSelectItem.options[index].children[i].list != undefined &&
          //         this.optionSelectItem.options[index].children[i].list != null &&
          //         this.optionSelectItem.options[index].children[i].list.length > 0) {
          //         for(let j = 0 ; j < this.optionSelectItem.options[index].children[i].list.length ; j++) {
          //           this.optionSelectItem.options[index].children[i].list[j].selected = false;
          //         }
          //       }
          //     }
          //   }
          // }
        }

        this.optionSelectionItemPrice();
      },
      updateChildOptionItemList: function() {

      },

      setSelectionChangeAmount: function(diff) {

        this.setSelectItem.amount += diff;
        if(this.setSelectItem.amount <= 0) {
          this.setSelectItem.amount = 1;
        }
        // console.log("Used Points " + this.optionSelectItem.pointsUsed);
        if(this.setSelectItem.pointsUsed > 0) {
          this.setSelectItem.amount = 1;
        }
        this.setelectionItemPrice();
      },
      setelectionItemPrice: function() {
        this.optionSelectItem.optionPrice = 0;
        for(let i = 0 ; i < this.optionSelectItem.options.length ; i++) {
          if(this.optionSelectItem.options[i].list == undefined || this.optionSelectItem.options[i].list.length == 0) {
            continue;
          }

          for(let j = 0 ; j < this.optionSelectItem.options[i].list.length ; j++) {
            if(this.optionSelectItem.options[i].list[j].selected == true) {
              if(this.optionSelectItem.options[i].list[j].field_price != undefined) {
                this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
              }
              // if(this.$data.type == 'delivery' && this.optionSelectItem.options[i].list[j].field_price_delivery && Number(this.optionSelectItem.options[i].list[j].field_price_delivery) > 0) {
              //   this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
              // }

            }
          }
          if(this.optionSelectItem.options[i].children != undefined && this.optionSelectItem.options[i].children.length > 0) {
            for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
              if (this.optionSelectItem.options[i].children[j].list != undefined &&
                this.optionSelectItem.options[i].children[j].list != null &&
                this.optionSelectItem.options[i].children[j].list.length > 0) {
                for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                  if (this.optionSelectItem.options[i].children[j].list[k].selected == true) {
                    this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].children[j].list[k].field_price * 100);
                  }
                }
              }
            }
          }
        }

        this.optionSelectItem.totalPrice = (this.optionSelectItem.price + this.optionSelectItem.optionPrice) * this.optionSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      optionSelectionChangeAmount: function(diff) {

        this.optionSelectItem.amount += diff;
        if(this.optionSelectItem.amount <= 0) {
          this.optionSelectItem.amount = 1;
        }
        // console.log("Used Points " + this.optionSelectItem.pointsUsed);
        if(this.optionSelectItem.pointsUsed > 0) {
          this.optionSelectItem.amount = 1;
        }
        this.optionSelectionItemPrice();
      },
      setSelectionItemPrice: function() {
        this.setSelectItem.optionPrice = 0;

        for(let i = 0 ; i < this.setSelectItem.sections.length ; i++) {

          if(this.setSelectItem.sections[i].products.length > 0) {
            for(let j = 0 ; j < this.setSelectItem.sections[i].products.length ; j++) {
              if(this.setSelectItem.sections[i].products[j].selected && this.setSelectItem.sections[i].products[j].options != undefined && this.setSelectItem.sections[i].products[j].options.length > 0) {
                for(let k = 0 ; k < this.setSelectItem.sections[i].products[j].options.length ; k++) {

                  if(this.setSelectItem.sections[i].products[j].options[k].list == undefined || this.setSelectItem.sections[i].products[j].options[k].list.length == 0) {
                    continue;
                  }
                  for(let l = 0 ; l < this.setSelectItem.sections[i].products[j].options[k].list.length ; l++) {
                    if(this.setSelectItem.sections[i].products[j].options[k].list[l].selected == true && this.setSelectItem.sections[i].products[j].options[k].list[l].field_price != undefined) {
                      this.setSelectItem.optionPrice += Number(this.setSelectItem.sections[i].products[j].options[k].list[l].field_price*100);
                    }
                  }
                }
              }
            }
          }


        }

        this.setSelectItem.totalPrice = (this.setSelectItem.price + this.setSelectItem.optionPrice) * this.setSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      optionSelectionItemPrice: function() {
        this.optionSelectItem.optionPrice = 0;
        for(let i = 0 ; i < this.optionSelectItem.options.length ; i++) {
          if(this.optionSelectItem.options[i].list == undefined || this.optionSelectItem.options[i].list.length == 0) {
            continue;
          }

          for(let j = 0 ; j < this.optionSelectItem.options[i].list.length ; j++) {
            if(this.optionSelectItem.options[i].list[j].selected == true) {
              if(this.optionSelectItem.options[i].list[j].field_price != undefined) {
                this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
              }
              // if(this.$data.type == 'delivery' && this.optionSelectItem.options[i].list[j].field_price_delivery && Number(this.optionSelectItem.options[i].list[j].field_price_delivery) > 0) {
              //   this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
              // }

            }
          }
          if(this.optionSelectItem.options[i].children != undefined && this.optionSelectItem.options[i].children.length > 0) {
            for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
              if (this.optionSelectItem.options[i].children[j].list != undefined &&
                this.optionSelectItem.options[i].children[j].list != null &&
                this.optionSelectItem.options[i].children[j].list.length > 0) {
                for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                  if (this.optionSelectItem.options[i].children[j].list[k].selected == true) {
                    this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].children[j].list[k].field_price * 100);
                  }
                }
              }
            }
          }
        }

        this.optionSelectItem.totalPrice = (this.optionSelectItem.price + this.optionSelectItem.optionPrice) * this.optionSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      redeemPoint: function() {
        // console.log("redeempoint" + this.$data.optionSelectItem.pricePoints);
        this.$data.optionSelectItem.price = 0;
        this.$data.optionSelectItem.amount = 1;
        this.$data.optionSelectItem.totalPrice = (this.$data.optionSelectItem.price + this.$data.optionSelectItem.optionPrice);
        this.$data.optionSelectItem.pointsUsed = this.$data.optionSelectItem.pricePoints;
        // console.log("redeempoint used " + this.$data.optionSelectItem.pointsUsed);
      },
      addSetToOrder: function() {
        if(this.$data.setSelectItem.sections != undefined && this.$data.setSelectItem.sections != null && this.$data.setSelectItem.sections.length > 0) {
          for(let i = 0 ; i < this.$data.setSelectItem.sections.length ; i++) {
            if(this.$data.setSelectItem.sections[i].products.length > 0) {

              // Check if at least one product is selected
              let sectionSelected = false;
              for(let j = 0 ; j < this.$data.setSelectItem.sections[i].products.length ; j++) {
                if(this.$data.setSelectItem.sections[i].products[j].selected) {
                  sectionSelected = true;

                  if(this.$data.setSelectItem.sections[i].products[j].options != undefined && this.$data.setSelectItem.sections[i].products[j].options != null && this.$data.setSelectItem.sections[i].products[j].options.length > 0) {
                    for(let k = 0 ; k < this.$data.setSelectItem.sections[i].products[j].options.length ; k++) {
                      if(this.$data.setSelectItem.sections[i].products[j].options[k].required != undefined && this.$data.setSelectItem.sections[i].products[j].options[k].required == true) {
                        if(this.$data.setSelectItem.sections[i].products[j].options[k].list != undefined && this.$data.setSelectItem.sections[i].products[j].options[k].list != null && this.$data.setSelectItem.sections[i].products[j].options[k].list.length > 0 ) {
                          let optionSelected = false;
                          for(let l = 0 ; l < this.$data.setSelectItem.sections[i].products[j].options[k].list.length ; l++) {
                            if(this.$data.setSelectItem.sections[i].products[j].options[k].list[l].selected == true) {
                              optionSelected = true;
                            }
                          }

                          if(optionsSelected == false) {
                            let productName = this.$data.setSelectItem.sections[i].products[j].public_name != null && this.$data.setSelectItem.sections[i].products[j].public_name.length > 0?this.$data.setSelectItem.sections[i].products[j].public_name:this.$data.setSelectItem.sections[i].products[j].name;
                            this.showModal("", "Please select option for " + productName + " in section " + this.$data.setSelectItem.sections[i].section_title);
                            return;
                          }
                        }
                      }
                    }
                  }
                }
              }

              if(sectionSelected == false) {
                this.showPopup("", "Please select one item from " + this.$data.setSelectItem.sections[i].section_title);
                return;
              }


            }
          }
        }
        if(this.$data.optionSelectItem.options != undefined && this.$data.optionSelectItem.options != null && this.$data.optionSelectItem.options.length > 0) {
          for(let i = 0 ; i < this.$data.optionSelectItem.options.length ; i++) {
            if(this.$data.optionSelectItem.options[i].required != undefined && this.$data.optionSelectItem.options[i].required == true) {
              //Now check if at least one is selected

              if(this.$data.optionSelectItem.options[i].list != undefined && this.$data.optionSelectItem.options[i].list != null && this.$data.optionSelectItem.options[i].list.length > 0) {
                let selected = false;
                for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                  if(this.$data.optionSelectItem.options[i].list[j].selected == true) {
                    selected = true;
                    break;
                  }
                }

                if(selected == false) {
                  this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].name);
                  return;
                }


              }
            }

          }
        }
        if(this.$data.type == 'table') {
          this.addOrderItemTable(JSON.parse(JSON.stringify(this.setSelectItem)));
        } else {
          this.addOrderItem(JSON.parse(JSON.stringify(this.setSelectItem)));
        }
        this.setSelectItem = false;
        this.closeTop();
      },
      addToOrder: function() {
        if(this.$data.optionSelectItem.options != undefined && this.$data.optionSelectItem.options != null && this.$data.optionSelectItem.options.length > 0) {
          for(let i = 0 ; i < this.$data.optionSelectItem.options.length ; i++) {
            if(this.$data.optionSelectItem.options[i].required != undefined && this.$data.optionSelectItem.options[i].required == true) {
              //Now check if at least one is selected

              if(this.$data.optionSelectItem.options[i].list != undefined && this.$data.optionSelectItem.options[i].list != null && this.$data.optionSelectItem.options[i].list.length > 0) {
                let selected = false;
                for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                  if(this.$data.optionSelectItem.options[i].list[j].selected == true) {
                    selected = true;
                    break;
                  }
                }

                if(selected == false) {
                  this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].name);
                  return;
                }


                if(this.$data.optionSelectItem.options[i].min_order > 1) {
                  let count = 0;
                  for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                    if (this.$data.optionSelectItem.options[i].list[j].selected == true) {
                      count += 1;
                    }
                  }

                  if(this.$data.optionSelectItem.options[i].min_order != count) {
                    this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].min_order + " choices for " + this.$data.optionSelectItem.options[i].name);
                    return;
                  }
                }
              }
            }
            let parentSelected = false;
            if(this.$data.optionSelectItem.options[i].list != undefined && this.$data.optionSelectItem.options[i].list != null && this.$data.optionSelectItem.options[i].list.length > 0) {
              for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                if(this.$data.optionSelectItem.options[i].list[j].selected == true) {
                  parentSelected = true;
                  break;
                }
              }
            }
            if(parentSelected == true && this.optionSelectItem.options[i].children != undefined && this.optionSelectItem.options[i].children.length > 0) {
              for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
                if(this.optionSelectItem.options[i].children[j].required != undefined && this.optionSelectItem.options[i].children[j].required == true) {
                  if (this.optionSelectItem.options[i].children[j].list != undefined &&
                    this.optionSelectItem.options[i].children[j].list != null &&
                    this.optionSelectItem.options[i].children[j].list.length > 0) {
                    let selected = false;
                    for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                      if (this.optionSelectItem.options[i].children[j].list[k].selected == true) {
                        selected = true;
                      }
                    }
                    if(selected == false) {
                      this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].children[j].name);
                      return;
                    }
                  }
                }
              }
            }
          }
        }
        if(this.$data.type == 'table' || this.$data.preorder == true) {
          this.addOrderItemTable(JSON.parse(JSON.stringify(this.optionSelectItem)));
        } else {
          this.addOrderItem(JSON.parse(JSON.stringify(this.optionSelectItem)));
        }
        this.optionSelectItem = false;
        this.closeTop();
      },
      itemAmountChanged: function(diff, index) {
        if(this.$data.order == false) {
          return;
        }

        if(this.$data.order.list == undefined || this.$data.order.list.length == 0 || this.$data.order.list.length <= index) {
          return;
        }

        // console.log(this.$data.order.list);
        if(this.$data.order.list[index].amount + diff <= 0) {
          this.confirmDeleteItem(index);
          return;
        }

        this.$data.order.list[index].amount += diff;
        this.$data.order.list[index].totalPrice = (this.$data.order.list[index].price + this.$data.order.list[index].optionPrice) * this.$data.order.list[index].amount;
        this.calculatePrice();
        if(this.$data.order.id > 0 && this.$data.order.list[index].id > 0) {
          let itemToUpdate = this.$data.order.list[index];
          let self = this;
          updateTableItem(itemToUpdate)
            .then(function(data) {
              if(data.success == true) {
                self.$data.order = data.item;
                self.notifyTableFriends();
              } else {
                self.showPopup("Sorry", data.message);
              }
            })
            .catch(function(err) {
              self.showPopup("Sorry", "Error happened. Please refresh page and try again");
            })
        }

      },
      getMenuAmount: function(menu) {
        // console.log(menu.name + "getMenuAmount");
        if(this.$data.order == false) {
          // console.log(menu.name + "getMenuAmount no order");
          return '';
        }

        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          // console.log(menu.name + "getMenuAmount no child order");
          return '';
        }
        let amount = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].menuId == menu.id) {
            amount+=this.$data.order.list[i].amount;
          }
        }

        if(amount == 0) {
          // console.log(menu.name + "getMenuAmount 0");
          return '';
        }
        // console.log(menu.name + " amount " + amount);
        return amount;
      },
      confirmDeleteItem: function(index) {
        // console.log("confirmDeleteItem");
        let self = this;
        this.showPopup("", "Remove " + this.$data.order.list[index].menuName + "?",
          "Remove", "No",
          function(){

            if(self.$data.order.id > 0 && self.$data.order.list[index].id > 0) {
              self.deleteTableOrderItem(index);
              return;
            }
            if(self.$data.order.list[index].pointsUsed > 0) {
              self.$data.order.pointsUsed = 0;
            }
            self.$data.order.list.splice(index, 1);
            self.calculatePrice();
          })
      },
      deleteTableOrderItem: function(index) {
        let id = this.$data.order.list[index].id;
        if(id == 0) {
          this.$data.order.list.splice(index, 1);
        } else {
          let self = this;
          this.setLoadingView(true, "Removing")
          if(this.$data.preorder == true) {
            deletePreOrderItem(id)
              .then(function (data) {
                self.setLoadingView(false);
                if (data.success == true) {
                  // if(data.item.list != undefined && data.item.list != null && data.item.list.length > 0) {
                  //   for(let i = 0 ; i < data.item.list.length ; i++) {
                  //     if(data.item.list[i].options != null && data.item.list[i].options.length > 0) {
                  //       data.item.list[i].options = JSON.parse(data.item.list[i].options);
                  //     }
                  //     if(data.item.list[i].optionSelection != null && data.item.list[i].optionSelection.length > 0) {
                  //       data.item.list[i].optionSelection = JSON.parse(data.item.list[i].optionSelection);
                  //     }
                  //   }
                  // }
                  self.$data.order = data.item;
                  // self.notifyTableFriends();
                } else {
                  self.showPopup("Sorry", data.message);
                }
              })
              .catch(function (err) {
                self.setLoadingView(false);
                self.showPopup("Sorry", "Error happened. please refresh page and try again")
              })
          } else {
            deleteTableItem(id)
              .then(function (data) {
                self.setLoadingView(false);
                if (data.success == true) {
                  self.$data.order = data.item;
                  self.notifyTableFriends();
                } else {
                  self.showPopup("Sorry", data.message);
                }
              })
              .catch(function (err) {
                self.setLoadingView(false);
                self.showPopup("Sorry", "Error happened. please refresh page and try again")
              })
          }
        }
      },
      getTotalCount: function() {
        let count = 0;
        if(this.$data.order != false && this.$data.order.list != undefined) {
          for(let i = 0 ; i < this.$data.order.list.length ; i++) {
            count += this.$data.order.list[i].amount;
          }
        }

        if(this.$data.lastCount != count) {
          // console.log("total count previous " + this.$data.lastCount);
          this.$data.lastCount = count;
          // console.log("total count changed " + count);
          let target = document.getElementById("basket-box");
          if(target != null) {
            target.classList.add("blink-box");
            setTimeout(this.removeBasketAnim, 2000);
          }
        }

        // this.$data.count = count;

        return count;
      },
      removeBasketAnim: function() {
        let target = document.getElementById("basket-box");
        if(target != null) {
          target.classList.remove("blink-box");
        }
      },
      getHistoryOrderItemName: function(item) {
        let title = item.menuName;
        let optionSelection = item.optionSelection;
        let optionList = [];
        if (optionSelection != null && optionSelection.length > 0) {
          let options = JSON.parse(optionSelection);
          for (let j = 0; j < options.length; j++) {
            if (options[j].field != undefined) {
              optionList.push(options[j].field);
            }
          }
        }


        if(optionList.length > 0) {
          title += ' (' + optionList.join(', ') + ')';
        }



        return title;
      },
      getOrderItemName: function(index) {
        if(this.$data.order == false) {
          return '';
        }


        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return '';
        }
        let name = '';
        if(this.$data.order.list[index].publicMenuName != undefined && this.$data.order.list[index].publicMenuName != null && this.$data.order.list[index].publicMenuName != '') {
          name = this.$data.order.list[index].publicMenuName;
        } else {
          name = this.$data.order.list[index].menuName;
        }
        let selectedOptions = [];
        if(this.$data.order.list[index].id > 0) {
          if(this.$data.order.list[index].optionSelection !== null && this.$data.order.list[index].optionSelection.length > 0) {
            let optionSelection =  JSON.parse(this.$data.order.list[index].optionSelection);

            for(let i = 0 ; i < optionSelection.length ; i++) {
              if(optionSelection[i].section != undefined) {
                let name = optionSelection[i].section + ": " + optionSelection[i].menu;

                let optionsNames = [];
                if(optionSelection[i].options != undefined && optionSelection[i].options != null && optionSelection[i].options.length > 0) {
                  for(let j = 0 ; j < optionSelection[i].options.length ; j++) {
                    optionsNames.push(optionSelection[i].options[j].field);
                  }

                }
                if(optionsNames.length > 0) {
                  name += "(" + optionsNames.join(',') + ')';
                }
                selectedOptions.push(name);
              } else {
                selectedOptions.push(optionSelection[i].field);
              }

            }
          }
          if(selectedOptions.length > 0) {
            name += '<br>' + selectedOptions.join('<br>');
          }
          return name;
        }

        // console.log(this.$data.order.list[index].options);
        if(this.$data.order.list[index].options != undefined && this.$data.order.list[index].options.length > 0) {
          for(let i = 0 ; i < this.$data.order.list[index].options.length ; i++) {

            let selected = false;

            if(this.$data.order.list[index].options[i].list != undefined) {
              for(let j = 0 ; j < this.$data.order.list[index].options[i].list.length ; j++) {
                if(this.$data.order.list[index].options[i].list[j].selected == true) {
                  selectedOptions.push(this.$data.order.list[index].options[i].list[j].field_name);
                  selected = true;
                }
              }
            }
            if(selected == true) {
              if(this.$data.order.list[index].options[i].children != undefined &&
                this.$data.order.list[index].options[i].children != null &&
                this.$data.order.list[index].options[i].children.length > 0) {
                for(let k = 0 ; k < this.$data.order.list[index].options[i].children.length ; k++) {
                  if(this.$data.order.list[index].options[i].children[k].list != undefined &&
                    this.$data.order.list[index].options[i].children[k].list != null &&
                    this.$data.order.list[index].options[i].children[k].list.length > 0) {
                    for(let l = 0 ; l < this.$data.order.list[index].options[i].children[k].list.length ; l++) {
                      if(this.$data.order.list[index].options[i].children[k].list[l].selected == true) {
                        selectedOptions.push(this.$data.order.list[index].options[i].children[k].list[l].field_name);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if(this.$data.order.list[index].sections != undefined && this.$data.order.list[index].sections.length > 0) {
          for(let i = 0 ; i < this.$data.order.list[index].sections.length ; i ++) {
            if(this.$data.order.list[index].sections[i].products != undefined && this.$data.order.list[index].sections[i].products != null && this.$data.order.list[index].sections[i].products.length > 0) {
              for(let j = 0 ; j < this.$data.order.list[index].sections[i].products.length ; j++) {
                if(this.$data.order.list[index].sections[i].products[j].selected == true) {
                  let selectedSection = this.$data.order.list[index].sections[i].section_title + ": " +this.$data.order.list[index].sections[i].products[j].public_name != null && this.$data.order.list[index].sections[i].products[j].public_name.length > 0 ? this.$data.order.list[index].sections[i].products[j].public_name:this.$data.order.list[index].sections[i].products[j].name;

                  if(this.$data.order.list[index].sections[i].products[j].options != undefined && this.$data.order.list[index].sections[i].products[j].options != null && this.$data.order.list[index].sections[i].products[j].options.length > 0) {
                    for(let k = 0 ; k < this.$data.order.list[index].sections[i].products[j].options.length ; k++) {
                      if(this.$data.order.list[index].sections[i].products[j].options[k].list != undefined && this.$data.order.list[index].sections[i].products[j].options[k].list != null && this.$data.order.list[index].sections[i].products[j].options[k].list.length > 0) {
                        let selectedSectionOptions = [];
                        for(let l = 0 ; l < this.$data.order.list[index].sections[i].products[j].options[k].list.length ; l++) {
                          if(this.$data.order.list[index].sections[i].products[j].options[k].list[l].selected == true) {
                            selectedSectionOptions.push(this.$data.order.list[index].sections[i].products[j].options[k].list[l].field_name);
                          }
                        }
                        if(selectedSectionOptions.length > 0) {
                          selectedSection += '(' + selectedSectionOptions.join(',') + ')';
                        }
                      }
                    }
                  }
                  selectedOptions.push(selectedSection);


                }
              }
            }
          }
        }
        if(selectedOptions.length > 0) {
          name += '<br>' + selectedOptions.join('<br>');
        }
        return name;
      },
      buildOptionSelection: function(item) {
        let list = [];
        if(item.sections !== undefined && item.sections.length > 0) {
          for(let i = 0 ; i < item.sections.length ; i++) {
            if(item.sections[i].products != undefined && item.sections[i].products != null && item.sections[i].products.length > 0) {
              for(let j = 0 ; j < item.sections[i].products.length ; j++) {
                if(item.sections[i].products[j].selected == true) {
                  let section = {
                    section:item.sections[i].section_title,
                    menu_id: item.sections[i].products[j].id,
                    menu: item.sections[i].products[j].public_name != undefined && item.sections[i].products[j].public_name.length > 0 ? item.sections[i].products[j].public_name : item.sections[i].products[j].name,
                    options:[],
                  }
                  if(item.sections[i].products[j].options != undefined && item.sections[i].products[j].options != null && item.sections[i].products[j].options.length > 0) {
                    for (let k = 0; k < item.sections[i].products[j].options.length; k++) {
                      if (item.sections[i].products[j].options[k].list != undefined && item.sections[i].products[j].options[k].list != null && item.sections[i].products[j].options[k].list.length > 0) {
                        for (let l = 0; l < item.sections[i].products[j].options[k].list.length; l++){
                          if(item.sections[i].products[j].options[k].list[l].selected != undefined && item.sections[i].products[j].options[k].list[l].selected == true) {

                            let option = {
                              option: item.sections[i].products[j].options[k].name,
                              field: item.sections[i].products[j].options[k].list[l].field_name,
                              price: item.sections[i].products[j].options[k].list[l].field_price,
                            }
                            if(item.sections[i].products[j].options[k].choice != undefined && item.sections[i].products[j].options[k].choice == 1) {
                              option.type = "single";
                            }

                            section.options.push(option);
                          }
                        }
                      }
                    }
                  }
                  list.push(section);
                }
              }
            }
          }
          if(item.memo != null && item.memo.length > 0) {
            let mo = {
              option: "memo",
              field: item.memo,
            }
            list.push(mo);
          }
          return list;
        }


        if(item.options == undefined || item.options.length == 0) {
          return '';
        }

        // let list = [];
        for(let i = 0 ; i < item.options.length ; i++) {
          let selected = false;
          for(let j = 0 ; j < item.options[i].list.length ; j++) {

            if(item.options[i].list[j].selected != undefined && item.options[i].list[j].selected == true) {
              let option = {
                option: item.options[i].name,
                field: item.options[i].list[j].field_name,
                price: item.options[i].list[j].field_price,
              }
              if(item.options[i].choice != undefined && item.options[i].choice == 1) {
                option.type = "single";
              }
              selected = true;
              list.push(option);
            }
          }
          if(selected == true) {
            if(item.options[i].children != undefined &&
              item.options[i].children != null &&
              item.options[i].children.length > 0) {
              for(let k = 0 ; k < item.options[i].children.length ; k++) {
                if(item.options[i].children[k].list != undefined &&
                  item.options[i].children[k].list != null &&
                  item.options[i].children[k].list.length > 0) {
                  for(let l = 0 ; l < item.options[i].children[k].list.length ; l++) {
                    if(item.options[i].children[k].list[l].selected == true) {
                      let option = {
                        option: item.options[i].children[k].name,
                        field: item.options[i].children[k].list[l].field_name,
                        price: item.options[i].children[k].list[l].field_price,
                      }
                      if(item.options[i].children[k].choice != undefined && item.options[i].children[k].choice == 1) {
                        option.type = "single";
                      }
                      list.push(option);
                    }
                  }
                }
              }
            }
          }
        }
        if(item.memo != null && item.memo.length > 0) {
          let mo = {
            option: "memo",
            field: item.memo,
          }
          list.push(mo);
        }
        return list;
      },
      setLoadingView: function(show, message = '') {
        this.$data.isLoading = show;
        this.$data.loadingMessage = message;
      },

      reorderItem: function() {
        if(this.$data.order == false) {
          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        this.$data.order.list.sort(function(a, b) {
          if(a.tags == null) {
            a.tags = '';
          }
          if(b.tags == null) {
            b.tags = '';
          }

          if(a.tags < b.tags) {
            return -1;
          } else if(a.tags > b.tags) {
            return 1;
          }
          return 0;
        })
        this.$data.order.list.sort(function(a,b) {
          if(a.menuName > b.menuName) {
            return 1;
          } else if(a.menuName < b.menuName) {
            return -1;
          }
          return 0;
        })
        this.$data.order.list.sort(function(a, b) {
          if(a.state < b.state) {
            return 1;
          } else if(a.state > b.state) {
            return -1;
          }
          return 0;
        })



        // console.log("reorder");
      },
      getPendingTable: function() {
        // console.log("Get pending table item if exists " + this.$data.tableItem.id);
        let self = this;
        let existed = this.$data.order != false?true:false;

        getTablePendingOrder(this.$data.tableItem.id)
          .then(function(data) {

            if(data.success == true) {
              // console.log("Pending table " + data.item);
              self.$data.order = data.item;
              self.reorderItem();
              self.subscribeTableOrder();
              // console.log(self.$data.order);
            } else {
              self.$data.order = false;
              if(existed) {
                self.showPopup("Thank you", "Session finished", "", "", null, null,
                  function(){
                    window.location.href = "https://eemo.app";
                  })
              }
            }
          })
          .catch(function(err){

          })
      },
      containAlcohol: function() {
        if(this.$data.order == false) {
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return false;
        }

        for(let i = 0; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].alcohol != undefined  && this.$data.order.list[i].alcohol == true) {
            return true;

          }
        }
        return false;
      },

      tableOrderable: function() {
        if(this.$data.order == false) {
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return false;
        }
        let orderableFound = false;
        for(let i = 0; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].state < 1) {
            orderableFound = true;
            break;
          }
        }
        return orderableFound;
      },
      askTableOrderTable: function() {
        this.$data.showTableOrderConfirm = true;
      },
      waitForTableOrder: function() {
        this.$data.showTableOrderConfirm = false;
      },
      placePreOrder: function() {
        // console.log(this.$data.order);
        if(this.$data.order == false) {

          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        this.$data.showTableOrderConfirm = false;
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));
        let self = this;
        this.setLoadingView(true, "Adding to order basket");
        submitTableOrder(orderItem)
          .then(function(data) {
            self.setLoadingView(false);
            if(data.success == true) {
              self.$data.showBasket = false;
              self.$data.order = data.item;
              self.reorderItem();
              self.showPopup("Order Submitted", "Your order is submitted.<br>After meal, please ask staff for your table bill.<br>You can order more food at any time.");
            } else {
              // console.log("Failed to place " + data.message);
            }
          })
          .catch(function(err) {
            // console.log("Error placing table order " + err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
            self.setLoadingView(false);
          })
      },
      placeTableOrder: function() {
        // console.log(this.$data.order);
        if(this.$data.order == false) {

          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        this.$data.showTableOrderConfirm = false;
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));
        let self = this;
        this.setLoadingView(true, "Adding to order basket");
        submitTableOrder(orderItem)
          .then(function(data) {
            self.setLoadingView(false);
            if(data.success == true) {
              self.$data.showBasket = false;
              self.$data.order = data.item;
              self.reorderItem();
              self.showPopup("Order Submitted", "Your order is submitted.<br>After meal, please ask staff for your table bill.<br>You can order more food at any time.");
            } else {
              // console.log("Failed to place " + data.message);
            }
          })
          .catch(function(err) {
            // console.log("Error placing table order " + err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
            self.setLoadingView(false);
          })
      },

      placeOrder: function(paymentMethod = 'tillCash') {
        let type = 'web';
        if(this.$data.type === 'table') {
          type = 'pos';
        }
        let self = this;
        if(this.$data.preorder == true) {
          this.placeOrderConfirmed(paymentMethod);
          return;
        }
        getMerchant(this.$data.merchantId, type)
          .then(function(data) {
            // let nowTime = new Date().getTime();
            // console.log("response took " + (nowTime - fromTime));
            if (data.success == true) {
              if(data.item.canTakeOrder == true) {
                self.placeOrderConfirmed(paymentMethod);
              } else {
                self.showPopup("", "Sorry. We currently cannot take order as we are too busy");
                return;
              }
            }
          })
          .catch(function(err) {
            self.showPopup("", "Unknown Error happened. Please try later");
            return;
          })
      },

      placeOrderConfirmed: function(paymentMethod = 'tillCash') {
        // if(this.$data.preorder == false && this.checkBeforeLastOrder() == false) {
        //   this.showPopup("Last Order", "Sorry last order time was " + this.getLastOrderTime());
        //   return;
        // }
        if(this.$data.currentMerchantItem.canTakeOrder == false && this.$data.preorder == false) {
          this.showPopup("", "Sorry. We currently cannot take order as we are too busy");
          this.showBasket = false;
          return;
        }
        if(this.$data.order == false) {
          // console.log("no order");
          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          // console.log("no order list");
          return;
        }

        // this.$data.order.recordType = 0;
        // console.log(this.$data.order);
        if(this.$data.preorder == false) {
          if (this.$data.order.recordType == 1 || this.$data.order.recordType == 2) {
            if (this.$data.order.pickupTime == '') {
              this.showPopup("", "Please choose time you wish to pick up")
              return;
            }
            if (this.$data.order.name == '' || this.$data.order.name.length == 0) {
              this.showPopup("", "Please enter name")
              return;
            }
            if (this.$data.order.phoneNumber == '' || this.$data.order.phoneNumber.length != 11) {
              this.showPopup("", "Please enter phoneNumber")
              return;
            }
            //Now check time
            let targetTime = new Date();
            let times = this.$data.order.pickupTime.split(':');
            targetTime.setHours(times[0]);
            targetTime.setMinutes(times[1]);

            let timeNow = new Date().getTime();
            if (this.$data.type === 'delivery') {
              timeNow += this.getDeliveryCustomerDelayMinutes() * 60000;
              // console.log("time check for delivery" + this.$data.deliveryDelay);
            } else if (this.$data.type === 'takeaway') {
              timeNow += this.$data.taDelay * 60000;
              // console.log("time check takeaway " + this.$data.taDelay);
            if (this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
              timeNow += this.$data.additionalDelay * 60000;
            }
            }
            // console.log("pickup : " + targetTime + " now + delay " + new Date(timeNow) );
            timeNow -= 300000
            if (targetTime.getTime() < timeNow) {
              let message = "Your ";
              if (this.$data.type === 'delivery') {
                message += "Delivery time is now rescalculated.";
              } else if (this.$data.type === 'takeaway') {
                message += "Pickup time is too early.";
                message += " Please select time again";
              }


              this.setTimeSlots();
              this.$data.order.pickupTime = '';
              this.showPopup("", message);
              this.showBasketView();


              return;
            }

            // if(targetTime.getTime() < timeNow.getTime() + (60000*30)) {
            //     this.showPopup("", "Time is too early. At least 30mins required");
            //     return;
            // }

            if (this.$data.order.name === null || this.$data.order.name.length == 0) {
              this.showPopup("", "Please enter name so we can call you");
              return;
            }
            if (this.$data.order.phoneNumber === null || this.$data.order.phoneNumber.length != 11) {
              this.showPopup("", "Please enter your phone number");
              return;
            }
            localStorage.setItem('tel', this.$data.order.phoneNumber);
            this.subscribe(localStorage.getItem("tel"));
          }
        }



        // console.log("check");
        // console.log(this.$data.order.list);
        // return;

        let orderItem = JSON.parse(JSON.stringify(this.$data.order));

        // console.log(orderItem.list)
        if(orderItem.memo.length > 0) {
          if(orderItem.memo.includes("'")) {
            orderItem.memo = orderItem.memo.replace("'", "");
          }
          if(orderItem.memo.includes('"')) {
            orderItem.memo = orderItem.memo.replace('"', "");
          }
          // orderItem.memo = orderItem.memo.replace(/[^a-zA-Z ]/g, "");
        }
        if(orderItem.name.length > 0) {
          orderItem.name = orderItem.name.replace(/"/g, '').replace(/'/g, '');
        }
        for(let i = 0 ; i < orderItem.list.length ; i++) {
          if(orderItem.list[i].id == 0) {
            orderItem.list[i].optionSelection = JSON.stringify(this.buildOptionSelection(orderItem.list[i]));
            orderItem.list[i].options = JSON.stringify(orderItem.list[i].options);
          }
          if(orderItem.list[i].memo.length > 0) {
            if(orderItem.list[i].memo.includes("'")) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace("'", "");
            }
            if(orderItem.list[i].memo.includes('"')) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace('"', "");
            }

          }
        }
        orderItem.paymentMethod = paymentMethod;
        if(this.$data.type === 'delivery') {
          orderItem.deliveryReadyTime = millisToHM(new Date().getTime() + this.getDeliveryKitchenPrepMinutes() * 60000);
        }
        if(paymentMethod === 'webCard' || paymentMethod === 'stripe' || paymentMethod === 'teya' || paymentMethod === 'dojo') {
          orderItem.state = -1;
        }
        // let description = {
        //   list:orderItem.list,
        // }
        // orderItem.description = JSON.stringify(description);
        // delete orderItem.list;
        let self = this;
        // console.log(orderItem);


        //EventBus.$emit("showLoading", true, "Placing Order...");
        this.setLoadingView(true, "Placing Order ...");
        submitOrder(orderItem)
          .then(function(data) {

            // console.log("submit order return ");
            // console.log(data);
            if(data.success == true) {


              self.$data.order = false;
              if(data.item.paymentMethod === 'dojo') {
                self.setLoadingView(false);
                self.startDojoPayment(data.item);
              } else if(data.item.paymentMethod == 'stripe') {
                self.setLoadingView(false);
                self.startStripPayment(data.item);
              } else if(data.item.paymentMethod === 'teya') {
                self.setLoadingView(false);
                self.startTeyaPayment(data.item);
              } else if(data.item.paymentMethod === 'tillCash' || data.item.paymentMethod === 'tillCard') {
                self.$data.order = false;
                self.$router.push('/myorder?id=' + data.item.id);
                // self.closeTop()
                // if(self.$data.orderHistory.length > 0) {
                //   self.$data.orderHistory.unshift(data.item);
                // } else {
                //   self.$data.orderHistory.push(data.item);
                // }
                // self.$data.showHistory = true;
                // let path = self.$data.basePath + "?histor";
                // self.$router.push(path);
                // let mqttMsg = {newOrder:data.item.id}
                // let topic = "pos/" + data.item.subscriptionId;

                // self.sendMessage(topic, JSON.stringify(mqttMsg));
                // self.populateOrderItem(data.item);
                // setTimeout(function(){
                //   self.setLoadingView(false);
                //   // EventBus.$emit("showLoading", false);
                //   let elem = document.getElementById("history-container");
                //   if(elem != null) {
                //     let target = document.getElementById("history-item-" + data.item.id);
                //     elem.scrollTop = target.offsetTop;
                //   }
                //
                // }, 500);
                // self.getUserPoint();
              }
            }
          })
          .catch(function(err) {
            // console.log(err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
            // EventBus.$emit("showLoading", false);
            self.setLoadingView(false);
            // console.log("Failed to place order "+ err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
          })
      },
      populateOrderItem: function(item) {
        // let list = JSON.parse(item.description);
        // if(list.list != undefined) {
        //   list = list.list;
        // }
        // item.list = list;
        this.$data.order = item;
      },



      showBasketView: function() {
        let self = this;
        getMerchant(this.$data.merchantId, this.$data.type)
          .then(function(data) {
            // let nowTime = new Date().getTime();
            // console.log("response took " + (nowTime - fromTime));
            if (data.success == true) {
              self.$data.currentMerchantItem = JSON.parse(JSON.stringify(data.item))
              self.setOpeningTime();
              if(data.item.canTakeOrder == true) {
                self.showBasketViewConfirmed();
              } else {
                self.showPopup("", "Sorry. We currently cannot take order as we are too busy");
                return;
              }
            }
          })
          .catch(function(err) {
            self.showPopup("", "Unknown Error happened. Please try later");
            return;
          })
      },
      showBasketViewConfirmed: function() {

        if(this.$data.preorder == true) {
          let self = this;
          this.setLoadingView(true, "Getting list");

          getPreOrder(this.$data.order.id)
            .then(function(data) {
              self.setLoadingView(false);
              if(data.success == true) {
                self.$data.order = data.item;
                self.reorderItem();
                // console.log(self.$data.order);
                self.$data.showBasket = true;
                let path = this.$data.basePath + '?showBasket';
                if(path !== this.$data.currentPath) {
                  self.$router.push(path);
                }

              }
            })
            .catch(function(err) {
              self.setLoadingView(false);
              // console.log("Getting pending order error " + err);
              if(err.response != undefined) {
                // console.log(err.response);
              }
            })
          return;
        }
        if(this.$data.type == 'table') {
          let self = this;
          this.setLoadingView(true, "Getting list");

          getTablePendingOrder(this.$data.tableItem.id)
            .then(function(data) {
              self.setLoadingView(false);
              if(data.success == true) {
                self.$data.order = data.item;
                self.reorderItem();
                // console.log(self.$data.order);
                self.$data.showBasket = true;
                let path = this.$data.basePath + '?showBasket';
                if(path !== this.$data.currentPath) {
                  self.$router.push(path);
                }

              }
            })
            .catch(function(err) {
              self.setLoadingView(false);
              // console.log("Getting pending order error " + err);
              if(err.response != undefined) {
                // console.log(err.response);
              }
            })
          return;
        }

        if(this.$data.order != false) {

          // if(this.checkBeforeLastOrder() == false) {
          //   this.showPopup("Last Order", "Sorry last order time was " + this.getLastOrderTime());
          //   return;
          // }

          // this.setTimeSlots();

          this.$data.order.pickupTime = '';
          if(this.$data.timeSlots.length > 0) {
            this.$data.order.pickupTime = this.$data.timeSlots[0];
          }
          this.$data.showBasket = true;
          let path = this.$data.basePath + '?showBasket';
          if(path !== this.$data.currentPath) {
            this.$router.push(path);
          }
        }
        // console.log("showBasket");
        // console.log(this.$data.order);
      },

      acceptChange: function(item) {
        item.state = 2;
        let self = this;
        updateMyOrder(item)
          .then(function(data) {
            if(data.success == true) {
              let mqttMsg = {
                customerAcceptedChange: item.id,
              }
              let topic = "pos/" + data.item.subscriptionId;
              self.sendMessage(topic, JSON.stringify(mqttMsg));
            }
          })
          .catch(function(err) {

          })
      },
      cancelChange: function(item) {
        item.state = 7;
        let self = this;
        updateMyOrder(function(data) {
          if(data.success == true) {
            let mqttMsg = {
              customerRejectedChange: item.id,
            }
            let topic = "pos/" + data.item.subscriptionId;
            self.sendMessage(topic, JSON.stringify(mqttMsg));
          }
        })
          .catch(function(err){

          })
      },
      handleScroll: function(event) {
        let restaurantPanelTop = event.srcElement.scrollTop;


        if(this.$data.preScrollPosition < 200 && restaurantPanelTop >= 200) {
          $("#place-title").addClass("horizontal-center");
          $("#back-btn").addClass("left-top-back-dark");
        } else if(this.$data.preScrollPosition >= 200 && restaurantPanelTop < 200) {
          $("#place-title").removeClass("horizontal-center");
          $("#back-btn").removeClass("left-top-back-dark");
        }
        this.$data.preScrollPosition = restaurantPanelTop;

        let activeCat = null;
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          let catView = document.getElementById("cat-menu-container-" + this.$data.currentMerchantItem.categories[i].id);
          if(catView != null) {
            let catBtn = document.getElementById("cat-" + this.$data.currentMerchantItem.categories[i].id);
            if (this.isScrolledIntoView(catView)) {
              if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active") == false) {
                catBtn.classList.add("active");
                if (activeCat == null) {
                  activeCat = catBtn;
                }
              }

            } else {
              if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active")) {
                catBtn.classList.remove("active");
              }
            }
          }
        }

        if(activeCat != null) {
          $("#cat-container").animate({scrollLeft: activeCat.offsetLeft - 15}, 100);
        }
      },
      isScrolledIntoView: function(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        if(elemTop <= 0 && elemBottom > window.innerHeight * 0.6) {
          return true;
        } else if(elemTop > 0 && elemTop <= window.innerHeight*0.6) {
          return true;
        } else if(elemTop >= 0 && elemBottom <= window.innerHeight) {
          return true;
        }
        return false;
      },

      getOrderStateString: function(state, type, merchantName) {
        if(state == 0) {
          return '<strong><span style="color:red">Waiting for acceptance</span></strong>';
        } else if(state == 1) {
          return 'Change Request!. Please Confirm change';
        } else if(state == 2) {
          return 'Change Accepted';
        } else if(state == 3) {
          return 'Your order is accepted.'
        } else if(state == 4) {
          return 'Your order is in kitchen';
        } else if(state == 5) {
          if(type == 1) {
            return 'Your order is ready for collection';
          } else if(type ==2) {
            return 'Your order is on the way to you';
          }
        } else if(state == 6) {
          return 'Done';
        } else if(state == 7) {
          return 'Cancelled';
        }
        return 'Unknown(' + state + ')';
      },


      startDojoPayment: function(order) {
        let self = this;
        this.setLoadingView(true, "Starting card payment ...");
        if (order.redirectUrl == null || order.redirectUrl === '') {
          order.redirectUrl = window.location.origin;
        }
        axios.post(process.env.SHOWMEMENU_API + 'dojo/session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
          .then(function(data) {
            self.setLoadingView(false);
            if (data.data.success === true && data.data.item && data.data.item.dojoPaymentLink) {
              window.location.replace(data.data.item.dojoPaymentLink);
              return;
            }
            self.showPopup("Card payment", (data.data && data.data.message) ? data.data.message : "Card payment is not available");
          })
          .catch(function() {
            self.setLoadingView(false);
            self.showPopup("Card payment", "Could not start card payment. Please try later");
          });
      },

      updatePaidItem: function() {
        let self = this;
        // console.log("update paid item");
        // console.log(this.$data.cardPayItem);
        updatePaymentItem(this.$data.cardPayItem)
          .then(function(data) {
            if(data.success == true) {
              self.$data.cardPayItem = false;
              self.$data.order = false;
              if(self.$data.orderHistory.length > 0) {
                self.$data.orderHistory.unshift(data.item);
              } else {
                self.$data.orderHistory.push(data.item);
              }
              self.$data.showHistory = true;
              let mqttMsg = {newOrder:data.item.id}
              let topic = "pos/" + data.item.subscriptionId;
              // self.sendMessage(topic, JSON.stringify(mqttMsg));
              // self.populateOrderItem(data.item);
              setTimeout(function(){
                let elem = document.getElementById("history-container");
                if(elem != null) {
                  let target = document.getElementById("history-item-" + data.item.id);
                  elem.scrollTop = target.offsetTop;
                }

              }, 100);
              self.getUserPoint();
            } else {

            }
          })
          .catch(function(err){
            self.$data.cardPayItem = false;
          })
      },
      setLastOrderTime: function() {
        let lastOrderDiff = this.$data.lastOrder;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        }

      },
      getLastOrderTime: function() {
        let lastOrderTime = this.$data.slots[this.$data.slots.length-1].to;
        let lastOrderDiff = this.$data.lastOrder;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        }
        lastOrderTime -= lastOrderDiff*60000;
        return millisToHM(lastOrderTime);
      },
      checkBeforeLastOrder: function() {
        let lastOrderTime = this.$data.slots[this.$data.slots.length-1].to;
        let lastOrderDiff = this.$data.lastOrder;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        }
        lastOrderTime -= lastOrderDiff*60000;
        let currentTime = new Date().getTime();

        if(currentTime > lastOrderTime + 60000) {
          return false;
        }
        return true;
      },
      applyOrderTimingDefaults: function() {
        var ta = Number(this.$data.taDelay);
        var delivery = Number(this.$data.deliveryDelay);
        var interval = Number(this.$data.interval);
        var perMile = Number(this.$data.deliveryTimePerMile);
        this.$data.taDelay = (!isFinite(ta) || ta <= 0) ? 15 : ta;
        this.$data.deliveryDelay = (!isFinite(delivery) || delivery <= 0) ? 30 : delivery;
        this.$data.interval = (!isFinite(interval) || interval < 5) ? 5 : interval;
        this.$data.deliveryTimePerMile = (!isFinite(perMile) || perMile < 0) ? 5 : Math.floor(perMile);
      },
      getDeliveryDistanceDelayMinutes: function() {
        var perMile = Number(this.$data.deliveryTimePerMile);
        var metres = Number(this.$data.distance);
        if (!isFinite(perMile) || perMile <= 0 || !isFinite(metres) || metres <= 0) {
          return 0;
        }
        return Math.ceil(metres / 1600) * perMile;
      },
      getDeliveryExtraDelayMinutes: function() {
        var extra = 0;
        if (this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
          extra += Number(this.$data.additionalDelay) || 0;
        }
        var kitchen = 0;
        if (this.$data.currentMerchantItem != null && this.$data.currentMerchantItem.delayTime != undefined) {
          kitchen = Number(this.$data.currentMerchantItem.delayTime) || 0;
        }
        if (this.$data.order != false && this.$data.order.list != null) {
          for (var i = 0; i < this.$data.order.list.length; i++) {
            var itemDelay = Number(this.$data.order.list[i].delay);
            if (isFinite(itemDelay) && itemDelay > kitchen) {
              kitchen = itemDelay;
            }
          }
        }
        extra += kitchen;
        return extra;
      },
      getDeliveryCustomerDelayMinutes: function() {
        return Number(this.$data.taDelay) + this.getDeliveryExtraDelayMinutes() + this.getDeliveryDistanceDelayMinutes();
      },
      getDeliveryKitchenPrepMinutes: function() {
        return Number(this.$data.taDelay) + this.getDeliveryExtraDelayMinutes();
      },
      setTimeSlots: function() {

        this.applyOrderTimingDefaults();
        let delay = this.$data.taDelay;
        if(this.$data.type === 'delivery') {
          delay = this.getDeliveryCustomerDelayMinutes();
        } else {
        if(this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
          delay += this.$data.additionalDelay;
        }
        if(this.$data.currentMerchantItem.delayTime != undefined) {

          delay += Number(this.$data.currentMerchantItem.delayTime);
        }
        }
        let currentTime = millisToHM(new Date().getTime()+(60000*delay));
        var x = Number(this.$data.interval); //minutes interval
        if (!(x >= 5)) {
          x = 5;
        }
        var times = []; // time array
        var tt = 0; // start time

        // console.log("interval " + x + " delay " + delay);
        let slotTime = new Date().getTime() + (60000*delay);

        // console.log("first slot " + millisToReadable(slotTime) + " from " + new Date() + " delay " + delay);
        let last = new Date();
        last.setHours(23);
        last.setMinutes(59);
        last.setSeconds(59);
        last.setMilliseconds(999);

        last = last.getTime();

        while(slotTime < last) {

          let inSlot = false;
          // console.log(millisToHM(slotTime));
          for(let j = 0 ; j < this.$data.slots.length ; j++) {
            // console.log("check " + millisToHM(this.$data.slots[j].from) + " to " + millisToHM(this.$data.slots[j].to))
            if(slotTime >= this.$data.slots[j].from && slotTime <= this.$data.slots[j].to) {
              inSlot = true;
              break;
            }
          }
          if(inSlot) {
            let newSlot = millisToHM(slotTime);
            times.push(newSlot);
            // console.log("Add to new")
          } else {
            // console.log("Exclude");
          }
          slotTime += (60000 * x);
        }
        if(times.length == 0) {
          times.push(millisToHM(this.$data.slots[this.$data.slots.length-1].to));
        }


        // let lastOrderDiff = this.$data.lastOrder;
        // if(this.$data.type == 'delivery') {
        //   lastOrderDiff = this.$data.lastDeliveryOrder;
        // }

        // console.log("set time " + this.$data.type);
        // console.log(this.$data.currentMerchantItem.delivery);
        // console.log(this.$data.currentMerchantItem.delivery);
        // if(this.$data.type === 'delivery' && this.$data.currentMerchantItem != undefined && this.$data.lastDeliveryOrder != undefined) {
        //   lastOrderDiff = this.$data.lastDeliveryOrder;
        // } else if(this.$data.currentMerchantItem != undefined && this.$data.lastOrder != undefined){
        //   lastOrderDiff = this.$data.lastOrder;
        // }
        // lastOrderDiff = lastOrderDiff*60000;


        //loop to increment the time and push results in array
        // for (var i=0;tt<24*60; i++) {
        //   var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
        //   var mm = (tt%60); // getting minutes of the hour in 0-55 format
        //   let newSlot =  ("0" + (hh)).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 12:00 AM/PM format]
        //   let now = new Date();
        //   now.setHours(hh);
        //   now.setMinutes(mm);
        //   let nowMil = now.getTime();
        //
        //   if(newSlot > currentTime) {
        //     let inSlot = false;
        //     for(let j = 0 ; j < this.$data.slots.length ; j++) {
        //       if(nowMil >= this.$data.slots[j].from && nowMil <= this.$data.slots[j].to) {
        //         inSlot = true;
        //         break;
        //       }
        //     }
        //     if(inSlot) {
        //       times.push(newSlot);
        //     }
        //   } else {
        //   }
        //   tt = tt + x;
        //
        // }
        this.$data.timeSlots = times;

      },
      getFieldIcon: function(fieldIcon) {
        let icons = fieldIcon.split(',');
        let html = "";
        for(let i = 0 ; i < icons.length ; i++) {
          if(icons[i]==='chilli') {
            html += '<i class="fas fa-pepper-hot" style="color:red;"></i>';
          } else if(icons[i] === 'vegan') {
            html += '<i class="fas fa-leaf" style="color:#2C9021;"></i>';
          }
        }

        return html;
      },
      sendMessage: function (topic, string) {
        if(this.$data.mqtt != null && this.$data.mqtt.isConnected()) {
          let message = new Paho.Message(string);
          message.destinationName = topic;
          // console.log("Sending message to  " + topic);
          // console.log(message);
          this.$data.mqtt.send(message);
        } else {
          // console.log("Not connected")
        }
      },
      onMqttFailure: function (message) {
        console.error('Request failed');
      },
      subscribeTableOrder: function() {
        if(this.$data.order != false && this.$data.order.id > 0) {
          this.subscribe(this.$data.order.id.toString());
        }

      },
      onMessageArrived: function (msg) {
        let msgStr = msg.payloadString;
        // console.log(msg);
        if (msgStr.startsWith("test")) {
          // console.log("return doing nothing")
          return;
        }
        let self = this;
        // console.log("Here")
        let item = JSON.parse(msgStr);

        // console.log("Received " + msgStr);
        let viewId = 0;

        let tableChannel = false;
        if(this.$data.order != false && this.$data.order.id > 0) {
          tableChannel = 'posPublic/' + this.$data.order.id.toString();
        }
        // console.log(msg);
        // console.log("Received mqtt " + msg.destinationName + " " + tableChannel );
        if(tableChannel != false && msg.destinationName === tableChannel) {
          this.getPendingTable();
          return;
        } else {
          // console.log("Received mqtt not matching " + msg.destinationName + " " + tableChannel );
        }
        if(item.changeRequest != undefined) {
          // console.log("changeRequest arrived")
          if(item.state != undefined && item.state == 1) {
            // console.log("now show popup");
            this.showPopup("Order Change", )
          }
          viewId = item.changeRequest;
          if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
            let self = this;
            getMyOrder(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
              .then(function(data) {
                // console.log("my order list ");
                // console.log(data);
                if(data.success == true) {
                  self.$data.orderHistory = data.item;
                  self.$data.showHistory = true;
                  let path = self.$data.basePath + '?status';
                  self.$router.push(path);
                  setTimeout(function(){
                    let elem = document.getElementById("history-container");
                    if(elem != null) {
                      let target = document.getElementById("history-item-" + viewId);
                      elem.scrollTop = target.offsetTop;
                    }

                  }, 100);
                  self.getUserPoint();
                }
              })
              .catch(function(err) {
                // console.log(err);
                // if(err.response != undefined) {
                //   console.log(err.response);
                // }
              })
            this.subscribe(localStorage.getItem("tel"));
          } else {
            // console.log("getHistory no tel");
          }
        } else if(item.soldOut != undefined) {
          let menuId = item.id;
          // console.log("item sold out change " + menuId + " " + item.soldOut);
          let found = false;
          if(this.$data.currentMerchantItem != false && this.$data.currentMerchantItem.categories != undefined && this.$data.currentMerchantItem.categories.length > 0) {
            for(let c = 0 ; c < this.$data.currentMerchantItem.categories.length ; c++) {
              if(this.$data.currentMerchantItem.categories[c].list != undefined && this.$data.currentMerchantItem.categories[c].list.length > 0) {
                for(let p = 0 ; p < this.$data.currentMerchantItem.categories[c].list.length ; p++) {
                  if(this.$data.currentMerchantItem.categories[c].list[p].id == menuId) {
                    this.$data.currentMerchantItem.categories[c].list[p].soldOut = item.soldOut;
                    found = true;
                    break;
                  }
                }
                if(found == true) {
                  break;
                }
              }
            }

            if(item.soldOut == 1 && this.$data.order != false && this.$data.order.list != undefined && this.$data.order.list.length > 0) {
              let listToRemove = [];

              for(let o  = this.$data.order.list.length -1  ; o >= 0 ; o--) {
                if(this.$data.order.list[o].menuId == menuId) {
                  listToRemove.push(this.$data.order.list[o].publicMenuName);
                  this.$data.order.list.splice(o, 1);

                }
              }
              if(listToRemove.length > 0) {
                this.showPopup(listToRemove.join(", ") + " now sold out");

              }
            }
          }


        } else if(item.inStock != undefined) {
          let menuId = item.id;
        } else {
          // console.log(item);
          if(item.canTakeOrder != undefined) {
            if(this.$data.currentMerchantItem != false && this.$data.currentMerchantItem.canTakeOrder != undefined) {
              if(this.$data.currentMerchantItem.canTakeOrder == true && item.canTakeOrder == 0) {
                this.showPopup("", "Sorry. We currently cannot take order as we are too busy");
                this.showBasket = false;

              } else if(this.$data.currentMerchantItem.canTakeOrder == false && item.canTakeOrder == 1) {
                this.showPopup("", "Hi, We can now accept order");
              }
              this.$data.currentMerchantItem.canTakeOrder = item.canTakeOrder == 1;
            }
          }
        }

        // if(msg.destinationName === 'yami/menus') {
        //   let item = JSON.parse(msgStr);
        //   for (let i = 0; i < self.$data.categories.length; i++) {
        //     for (let j = 0; j < self.$data.categories[i].products.length; j++) {
        //       if(item.id == self.$data.categories[i].products[j].id) {
        //         self.$data.categories[i].products[j].soldOut = item.soldOut;
        //       }
        //     }
        //   }
        // } else {
        //
        //   let item = JSON.parse(msgStr);
        //   if (item != undefined) {
        //     this.getPendingOrder(item.id, false);
        //   }
        // }
      },
      subscribe: function(channel) {
        if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
          // console.log("MQTT is not connected");
          return;
        }
        for(let i = 0 ; i < this.$data.topics.length ; i++) {
          // console.log("Already subscribed " + this.$data.topics[i]);
          if(this.$data.topics[i] === channel) {
            // console.log("Already " + channel);
            return;
          }
        }
        // console.log("Subscribe now " + channel);
        this.$data.mqtt.subscribe("posPublic/" + channel);
        this.$data.topics.push(channel);
        //this.sendMessage("Hello I am customer");
      },
      onConnectionLost: function(resObj) {
        // console.log("connection lost");
        // this.$data.mqttConnected = false;
        this.$data.mqtt = null;
        // console.log("Lost connection to " + resObj.uri + "\nError code: " + resObj.errorCode + "\nError text: " + resObj.errorMessage);
        if(this.$data.mqttDisconnect == false) {
          this.connect();
        }
      },
      disconnect: function() {
        this.$data.mqttDisconnect = true;
        if(this.$data.mqtt != null && this.$data.mqtt.isConnected()) {
          this.$data.mqtt.disconnect();
        }
      },
      onConnect: function () {
        
        if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
          // console.log("onConnect but " + this.$data.mqtt);
          return;
        }
        if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
          this.subscribe(localStorage.getItem("tel"));
        }
        if(this.$data.currentMerchantItem != false) {
          this.subscribe("merchant/" + this.$data.currentMerchantItem.merchantId)
        }

        this.subscribeTableOrder();

      },
      connect: function () {
        this.$data.topics = [];
        this.$data.mqtt = new Paho.Client("mqtt.boriumstudio.com", Number(9001), "clientjsasdasd" + new Date().getTime());
        this.$data.mqtt.onConnectionLost = this.onConnectionLost;
        let options = {
          timeout: 3,
          useSSL: true,
          userName: "borium",
          password: "borium1234",
          onSuccess: this.onConnect,
          onFailure: this.onMqttFailure,
          reconnect : false,
        };
        this.$data.mqtt.onMessageArrived = this.onMessageArrived;
        // console.log("### Connect to MQTT ");
        this.$data.mqtt.connect(options); //connect
      },


      startTeyaPayment: function(order) {
        let self = this;
        if (order.redirectUrl == null || order.redirectUrl === '') {
          order.redirectUrl = window.location.origin;
        }
        axios.post(process.env.SHOWMEMENU_API + 'teya/session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
          .then(function(data) {
            if (data.data.success === true && data.data.item && data.data.item.teyaSessionUrl) {
              window.location.href = data.data.item.teyaSessionUrl;
              return;
            }
          })
          .catch(function() {
          });
      },

      startStripPayment: function(order) {
        // this.$data.stripe = Stripe('pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN');
        if(this.$data.currentMerchantItem.merchantId == 1) {
          this.$data.stripe = Stripe("pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN");
        } else {
          this.$data.stripe = Stripe('pk_live_51HKwg5FVWak6exTyclUWJpjsxbB8FTQKlF8oJp7QKEUk85qdeiJsSvLhOlVpYuCmJPQBGekUbO0DzY8pbwEgiZyD00evV7J3KP');
        }

        let purchase = [];
        for(let i = 0 ; i < order.list.length ; i++) {

          let purchaseItem = {
            id: order.list[i].name + ' x' + order.list[i].amount,
          };
          purchase.push(purchaseItem);

        }
        if(order.deliveryCharge > 0) {
          purchase.push({id:'Delivery Charge'});
        }
        let self = this;
        axios.post(process.env.SHOWMEMENU_API + 'stripe/create-session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
          // .then(function(data) {
          //   console.log(data);
          //   self.$data.stripeCardPayment = {
          //     cardNumber:'',
          //       expMonth:'',
          //       expYear:'',
          //       cvc:'',
          //   }
          // })
          .then(function(data) {
            // console.log(data);
            return self.$data.stripe.redirectToCheckout({ sessionId: data.data.item.pgToken });
          })
          // .then(function(session){
          //
          // })
          .catch(function(err) {
            // console.log(err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
          })
      },
      chargeCreditCard: function() {
        let self = this;
        Stripe.card.createToken({
          number: this.$data.stripeCardPayment.cardNumber,
          exp_month: this.$data.stripeCardPayment.expMonth,
          exp_year:  this.$data.stripeCardPayment.expYear,
          cvc:  this.$data.stripeCardPayment.cvc,

        }, (status, response) => {
          if (status === 200) {
            let token = response.id;
            // self.chargeCard(token);
            // console.log("Response from Stripe");
            // console.log(token);
            // console.log(response);
          } else {
            // console.log(response.error.message);
          }
        })
      },
      setPageMeta: function() {
        const titleEl = document.querySelector('head title');
        const descEl = document.querySelector('head meta[name="description"]');
        const keywordsEl = document.querySelector('head meta[name="keywords"]');

        let title =this.$data.currentMerchantItem.title;
        let key = this.$data.currentMerchantItem.title;
        let description = "Simple click and collect & Takeaway and delivery order for " + this.$data.currentMerchantItem.title;
        if(this.$data.currentMerchantItem.region !== undefined && this.$data.currentMerchantItem.region != null && this.$data.currentMerchantItem.region.length > 0) {
          title += " in " + this.$data.currentMerchantItem.region;
          key += "," + this.$data.currentMerchantItem.region;
          description += " in " + this.$data.currentMerchantItem.region;
        }
        key += ", takeaway, delivery";
        if(this.$data.currentMerchantItem.tags !== undefined && this.$data.currentMerchantItem.tags != null && this.$data.currentMerchantItem.tags.length > 0) {
          key += "," + this.$data.currentMerchantItem.tags;
        }
        title += " Takeaway | Delivery | Menu | Price | Show Me The Menu";
        titleEl.textContent = title;

        descEl.setAttribute('content', description);
        keywordsEl.setAttribute('content', key);

      },
      // chargeCard: function(token) {
      //   const headers = new Headers({'token': token, 'amount': 100});
      //   this.http.post('http://192.:9090/payment/charge', {}, {headers: headers})
      //     .subscribe(resp => {
      //       console.log(resp);
      //     })
      // }
    }
  }
</script>

<style scoped>
  #ps-payment iframe { width: 100%; }

  #demo-result, #ps-payment, #recurring-demo-payment, #recurring-payment { padding: 5px; }

  #errors li { color: #B00; }


  .connect-container { margin-top: 80px; }

  .slider-indicator-icon {
    background-color: white;
  }

  .wait-accept {
    background-color: #A7F1A7;
  }

</style>




// WEBPACK FOOTER //
// src/components/Shop.vue